// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.elibrary-header {
  background: #fff;
  padding: 0.75rem 1rem;
  border-radius: 10px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
}
.elibrary-header .header-left {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}
.elibrary-header .header-left .edit-btn {
  background: #eef2ff;
  color: #3b82f6;
  border-radius: 50%;
  padding: 0.4rem 0.5rem;
  cursor: pointer;
  transition: all 0.2s ease;
  font-size: 0.9rem;
}
.elibrary-header .header-left .edit-btn:hover {
  background: #dbeafe;
  color: #2563eb;
}
.elibrary-header .header-left .class-info {
  display: flex;
  flex-direction: column;
}
.elibrary-header .header-left .class-info .class-title {
  font-size: 1rem;
  font-weight: 600;
  color: #111827;
  margin: 0;
  max-width: 220px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.elibrary-header .header-left .class-info .class-updated {
  font-size: 0.75rem;
  color: #6b7280;
}
.elibrary-header .header-right {
  display: flex;
  align-items: center;
  gap: 1rem;
  flex-wrap: wrap;
}
.elibrary-header .header-right .search-box {
  position: relative;
}
.elibrary-header .header-right .search-box .input-search {
  padding: 0.4rem 1.8rem 0.4rem 2rem;
  border-radius: 8px;
  border: 1px solid #d1d5db;
  font-size: 0.9rem;
  transition: all 0.2s;
}
.elibrary-header .header-right .search-box .input-search:focus {
  outline: none;
  border-color: #3b82f6;
  box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.2);
}
.elibrary-header .header-right .search-box .search-icon {
  position: absolute;
  left: 8px;
  top: 8px;
  color: #9ca3af;
  font-size: 0.9rem;
}
.elibrary-header .header-right .search-box .clear-icon {
  position: absolute;
  right: 8px;
  top: 8px;
  color: #6b7280;
  cursor: pointer;
  font-size: 0.9rem;
}
.elibrary-header .header-right .search-box .clear-icon:hover {
  color: #ef4444;
}
.elibrary-header .header-right .view-toggle {
  display: flex;
  gap: 0.4rem;
}
.elibrary-header .header-right .view-toggle .toggle-btn {
  border: 1px solid #d1d5db;
  background: #f9fafb;
  border-radius: 6px;
  padding: 0.3rem 0.6rem;
  cursor: pointer;
  transition: all 0.2s ease;
}
.elibrary-header .header-right .view-toggle .toggle-btn:hover {
  background: #f3f4f6;
}
.elibrary-header .header-right .view-toggle .toggle-btn.active {
  background: #3b82f6;
  color: #fff;
  border-color: #3b82f6;
}
.elibrary-header .header-right .view-toggle .toggle-btn i {
  font-size: 0.9rem;
}
.elibrary-header .header-right .action-buttons {
  display: flex;
  gap: 0.6rem;
}
.elibrary-header .header-right .action-buttons .btn {
  border: none;
  border-radius: 6px;
  font-size: 0.85rem;
  display: flex;
  align-items: center;
  gap: 0.3rem;
  padding: 0.35rem 0.75rem;
  cursor: pointer;
  transition: all 0.2s ease;
}
.elibrary-header .header-right .action-buttons .btn i {
  font-size: 0.85rem;
}
.elibrary-header .header-right .action-buttons .btn.upload-btn {
  background: #10b981;
  color: #fff;
}
.elibrary-header .header-right .action-buttons .btn.upload-btn:hover {
  background: #059669;
}
@media (max-width: 768px) {
  .elibrary-header .header-right .action-buttons .btn.upload-btn .text {
    display: none;
  }
}
.elibrary-header .header-right .action-buttons .btn.close-btn {
  background: #f87171;
  color: #fff;
}
.elibrary-header .header-right .action-buttons .btn.close-btn:hover {
  background: #dc2626;
}

.elib-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #ffffff;
  border-bottom: 1px solid #e0e0e0;
  padding: 0.75rem 1rem;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);
  position: sticky;
  top: 0;
  z-index: 20;
  /* Responsive */
}
.elib-header .elib-header-left {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}
.elib-header .elib-header-left .toggle-btn {
  background: #f5f6fa;
  border: none;
  border-radius: 8px;
  padding: 0.4rem 0.6rem;
  cursor: pointer;
  transition: all 0.3s ease;
}
.elib-header .elib-header-left .toggle-btn:hover {
  background: #e3e6f0;
}
.elib-header .elib-header-left .toggle-btn i {
  font-size: 1.2rem;
  color: #555;
}
.elib-header .elib-header-left .class-info {
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.elib-header .elib-header-left .class-info .class-name {
  font-size: 1rem;
  font-weight: 600;
  color: #2c3e50;
  margin: 0;
}
.elib-header .elib-header-left .class-info .updated-time {
  font-size: 0.8rem;
  color: #888;
}
.elib-header .elib-header-left .action-icons {
  display: flex;
  align-items: center;
  list-style: none;
  gap: 0.75rem;
  margin: 0;
  padding: 0;
}
.elib-header .elib-header-left .action-icons .ai-button {
  border: 1px solid #dcdcdc;
  border-radius: 8px;
  padding: 0.4rem 0.6rem;
  cursor: pointer;
  transition: all 0.3s ease;
  background: #e7eaf0;
}
.elib-header .elib-header-left .action-icons li {
  cursor: pointer;
  padding: 0.5rem;
  border-radius: 6px;
  transition: background 0.3s;
}
.elib-header .elib-header-left .action-icons li:hover {
  background: #f1f3f7;
}
.elib-header .elib-header-left .action-icons li:has(.btn-icon) {
  padding: 0;
  background: transparent;
}
.elib-header .elib-header-left .action-icons li:has(.btn-icon):hover {
  background: transparent;
}
.elib-header .elib-header-left .action-icons li i {
  font-size: 1.1rem;
  color: #555;
}
.elib-header .elib-header-left .action-icons li img {
  width: 30px;
}
.elib-header .elib-header-left .action-icons li .btn-icon {
  background: #f8f9fb;
  border: 1px solid #dcdcdc;
  border-radius: 8px;
  padding: 4px 6px;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
}
.elib-header .elib-header-left .action-icons li .btn-icon:hover {
  background: #e7eaf0;
  border-color: #b8bcc4;
}
.elib-header .elib-header-left .action-icons li .btn-icon img {
  width: 30px;
  height: auto;
  display: block;
}
.elib-header .elib-header-right {
  display: flex;
  align-items: center;
  gap: 1rem;
}
.elib-header .elib-header-right .elib-actions {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}
.elib-header .elib-header-right .elib-actions .btn-icon {
  background: #f8f9fb;
  border: 1px solid #dcdcdc;
  border-radius: 8px;
  padding: 0.4rem 0.6rem;
  cursor: pointer;
  transition: all 0.3s ease;
}
.elib-header .elib-header-right .elib-actions .btn-icon:hover {
  background: #e7eaf0;
}
.elib-header .elib-header-right .elib-actions .btn-icon i {
  color: #007ad9;
  font-size: 1rem;
}
.elib-header .elib-header-right .elib-actions .search-box {
  position: relative;
  display: flex;
  align-items: center;
  background: #f8f9fb;
  border: 1px solid #dcdcdc;
  border-radius: 20px;
  padding: 0.3rem 0.8rem;
}
.elib-header .elib-header-right .elib-actions .search-box:focus-within {
  border-color: #007ad9;
}
.elib-header .elib-header-right .elib-actions .search-box .search-input {
  border: none;
  background: transparent;
  outline: none;
  flex: 1;
  font-size: 0.9rem;
  color: #333;
}
.elib-header .elib-header-right .elib-actions .search-box .left-icon,
.elib-header .elib-header-right .elib-actions .search-box .right-icon {
  color: #999;
  font-size: 0.85rem;
}
.elib-header .elib-header-right .elib-actions .search-box .left-icon {
  margin-right: 0.4rem;
}
.elib-header .elib-header-right .elib-actions .search-box .right-icon {
  cursor: pointer;
  margin-left: 0;
}
.elib-header .elib-header-right .elib-actions .search-box .right-icon:hover {
  color: #555;
}
@media (max-width: 766px) {
  .elib-header {
    flex-wrap: wrap;
    gap: 0.75rem;
    padding: 0.5rem 0.75rem;
  }
  .elib-header .elib-header-left {
    width: 100%;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 0.5rem;
  }
  .elib-header .elib-header-left .class-info {
    flex: 1;
    min-width: 0;
  }
  .elib-header .elib-header-left .class-info .class-name {
    font-size: 0.9rem;
    max-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .elib-header .elib-header-left .class-info .updated-time {
    font-size: 0.7rem;
  }
  .elib-header .elib-header-left .action-icons {
    gap: 0.5rem;
  }
  .elib-header .elib-header-left .action-icons li {
    padding: 0.4rem;
    min-width: 40px;
    min-height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .elib-header .elib-header-left .action-icons li:has(.btn-icon) {
    padding: 0;
    min-width: auto;
    min-height: auto;
  }
  .elib-header .elib-header-left .action-icons li img {
    width: 24px;
  }
  .elib-header .elib-header-left .action-icons li .btn-icon {
    min-width: 44px;
    min-height: 44px;
    padding: 0.5rem;
  }
  .elib-header .elib-header-left .action-icons li .btn-icon img {
    width: 24px;
  }
  .elib-header .elib-header-right {
    width: 100%;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 0.5rem;
  }
  .elib-header .elib-header-right .elib-actions {
    width: 100%;
    flex-wrap: wrap;
    gap: 0.5rem;
  }
  .elib-header .elib-header-right .elib-actions .btn-icon {
    min-width: 44px;
    min-height: 44px;
    padding: 0.5rem;
    font-size: 0.85rem;
  }
  .elib-header .elib-header-right .elib-actions .btn-icon i {
    font-size: 0.9rem;
  }
  .elib-header .elib-header-right .elib-actions .search-box {
    width: 100%;
    max-width: 100%;
    flex: 1;
    min-width: 0;
  }
  .elib-header .elib-header-right .elib-actions .search-box:focus-within {
    width: 100%;
  }
}
@media (max-width: 480px) {
  .elib-header {
    padding: 0.5rem;
  }
  .elib-header .elib-header-left .toggle-btn {
    min-width: 44px;
    min-height: 44px;
    padding: 0.5rem;
  }
  .elib-header .elib-header-left .class-info .class-name {
    font-size: 0.85rem;
  }
  .elib-header .elib-header-left .class-info .updated-time {
    font-size: 0.65rem;
  }
  .elib-header .elib-header-left .action-icons {
    gap: 0.4rem;
  }
  .elib-header .elib-header-left .action-icons li {
    padding: 0.35rem;
    min-width: 36px;
    min-height: 36px;
  }
  .elib-header .elib-header-left .action-icons li:has(.btn-icon) {
    padding: 0;
    min-width: auto;
    min-height: auto;
  }
  .elib-header .elib-header-left .action-icons li img {
    width: 20px;
  }
  .elib-header .elib-header-left .action-icons li .btn-icon {
    min-width: 40px;
    min-height: 40px;
    padding: 0.4rem;
  }
  .elib-header .elib-header-left .action-icons li .btn-icon img {
    width: 20px;
  }
  .elib-header .elib-header-right .elib-actions .btn-icon {
    font-size: 0.8rem;
    padding: 0.4rem 0.5rem;
  }
  .elib-header .elib-header-right .elib-actions .btn-icon i {
    font-size: 0.85rem;
  }
}

.elib-container {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  overflow: hidden;
}
.elib-container .elib-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  padding: 1rem;
}
.elib-container .elib-content .elib-scroll-area {
  height: 100%;
  /* or fixed height like 80vh or 500px */
  max-height: calc(100vh - 114px);
  /* adjust if inside a modal or layout */
  overflow-y: auto;
  overflow-x: hidden;
  scroll-behavior: smooth;
}
.elib-container .elib-content .elib-scroll-area::-webkit-scrollbar {
  width: 6px;
}
.elib-container .elib-content .elib-scroll-area::-webkit-scrollbar-thumb {
  background: #bdbdbd;
  border-radius: 4px;
}
.elib-container .elib-content .elib-scroll-area::-webkit-scrollbar-thumb:hover {
  background: #9e9e9e;
}
.elib-container .elib-content .elib-tile-view,
.elib-container .elib-content .elib-dashboard {
  flex-wrap: wrap;
  gap: 1rem;
  transition: all 0.3s ease-in-out;
}
.elib-container .elib-content .elib-tile-view app-e-library-tile,
.elib-container .elib-content .elib-tile-view app-e-library-dashboard,
.elib-container .elib-content .elib-dashboard app-e-library-tile,
.elib-container .elib-content .elib-dashboard app-e-library-dashboard {
  width: 100%;
  background: #fff;
  border-radius: 0.75rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}
.elib-container .elib-content .elib-tile-view app-e-library-tile:hover,
.elib-container .elib-content .elib-tile-view app-e-library-dashboard:hover,
.elib-container .elib-content .elib-dashboard app-e-library-tile:hover,
.elib-container .elib-content .elib-dashboard app-e-library-dashboard:hover {
  transform: translateY(-3px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

/* Optional responsive adjustments */
@media (max-width: 992px) {
  .elib-content {
    padding: 0.5rem;
  }
  .elib-content .elib-tile-view,
  .elib-content .elib-dashboard {
    gap: 0.75rem;
  }
}
/* Tablet range: 767px - 940px - Specific fix for mobile responsive */
@media (min-width: 767px) and (max-width: 940px) {
  .elib-header {
    padding: 0.65rem 0.9rem !important;
    flex-wrap: nowrap !important;
    display: flex !important;
    align-items: center !important;
  }
  .elib-header .elib-header-left {
    flex: 1 1 auto !important;
    min-width: 0 !important;
    width: auto !important;
    gap: 0.85rem !important;
    justify-content: flex-start !important;
    flex-wrap: nowrap !important;
    display: flex !important;
    align-items: center !important;
  }
  .elib-header .elib-header-left .toggle-btn {
    flex-shrink: 0 !important;
    min-width: 40px !important;
    min-height: 40px !important;
  }
  .elib-header .elib-header-left .class-info {
    flex: 1 1 auto !important;
    min-width: 0 !important;
    overflow: hidden !important;
  }
  .elib-header .elib-header-left .class-info .class-name {
    font-size: 0.95rem !important;
    max-width: 160px !important;
    overflow: hidden !important;
    text-overflow: ellipsis !important;
    white-space: nowrap !important;
  }
  .elib-header .elib-header-left .class-info .updated-time {
    font-size: 0.75rem !important;
  }
  .elib-header .elib-header-left .action-icons {
    gap: 0.5rem !important;
    flex-shrink: 0 !important;
    display: flex !important;
    align-items: center !important;
  }
  .elib-header .elib-header-left .action-icons li {
    padding: 0.4rem !important;
    min-width: 36px !important;
    min-height: 36px !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
  }
  .elib-header .elib-header-left .action-icons li img {
    width: 24px !important;
    height: auto !important;
  }
  .elib-header .elib-header-right {
    flex: 0 0 auto !important;
    width: auto !important;
    gap: 0.75rem !important;
    justify-content: flex-end !important;
    flex-wrap: nowrap !important;
    display: flex !important;
    align-items: center !important;
  }
  .elib-header .elib-header-right .elib-actions {
    width: auto !important;
    gap: 0.6rem !important;
    flex-wrap: nowrap !important;
    display: flex !important;
    align-items: center !important;
  }
  .elib-header .elib-header-right .elib-actions .btn-icon {
    padding: 0.4rem 0.5rem !important;
    font-size: 0.85rem !important;
    min-width: 40px !important;
    min-height: 40px !important;
    white-space: nowrap !important;
  }
  .elib-header .elib-header-right .elib-actions .btn-icon i {
    font-size: 0.9rem !important;
  }
  .elib-header .elib-header-right .elib-actions .search-box {
    width: 160px !important;
    max-width: 160px !important;
    flex: 0 0 auto !important;
    min-width: 160px !important;
  }
  .elib-header .elib-header-right .elib-actions .search-box:focus-within {
    width: 200px !important;
    max-width: 200px !important;
  }
  .elib-header .elib-header-right .elib-actions .search-box .search-input {
    font-size: 0.85rem !important;
  }
  .elib-content {
    padding: 0.75rem !important;
  }
  .elib-content .elib-scroll-area {
    max-height: calc(100vh - 170px) !important;
  }
  .elib-content .elib-tile-view,
  .elib-content .elib-dashboard {
    gap: 0.65rem !important;
  }
  .modal-container {
    width: 90% !important;
    max-width: 600px !important;
  }
  .upload-modal {
    width: 90% !important;
    max-width: 700px !important;
  }
  .more-user-modal .modern-modal {
    max-width: 500px !important;
    width: 90% !important;
  }
  .modal-body {
    padding: 1.25rem !important;
  }
  .modal-footer {
    padding: 0.9rem 1.25rem !important;
  }
}
/* Tablet range: 767px - 956px */
@media (min-width: 767px) and (max-width: 956px) {
  .elib-header {
    padding: 0.65rem 0.9rem !important;
    flex-wrap: nowrap !important;
  }
  .elib-header .elib-header-left {
    flex: 1 !important;
    min-width: 0 !important;
    width: auto !important;
    gap: 0.85rem !important;
    justify-content: flex-start !important;
    flex-wrap: nowrap !important;
  }
  .elib-header .elib-header-left .class-info {
    flex: 1 !important;
    min-width: 0 !important;
  }
  .elib-header .elib-header-left .class-info .class-name {
    font-size: 0.95rem !important;
    max-width: 180px !important;
  }
  .elib-header .elib-header-left .class-info .updated-time {
    font-size: 0.75rem !important;
  }
  .elib-header .elib-header-left .action-icons {
    gap: 0.6rem !important;
  }
  .elib-header .elib-header-left .action-icons li {
    padding: 0.45rem !important;
    min-width: 38px !important;
    min-height: 38px !important;
  }
  .elib-header .elib-header-left .action-icons li img {
    width: 26px !important;
  }
  .elib-header .elib-header-right {
    flex: 0 0 auto !important;
    width: auto !important;
    gap: 0.85rem !important;
    justify-content: flex-end !important;
    flex-wrap: nowrap !important;
  }
  .elib-header .elib-header-right .elib-actions {
    width: auto !important;
    gap: 0.65rem !important;
    flex-wrap: nowrap !important;
  }
  .elib-header .elib-header-right .elib-actions .btn-icon {
    padding: 0.45rem 0.55rem !important;
    font-size: 0.88rem !important;
    min-width: 42px !important;
    min-height: 42px !important;
  }
  .elib-header .elib-header-right .elib-actions .btn-icon i {
    font-size: 0.95rem !important;
  }
  .elib-header .elib-header-right .elib-actions .search-box {
    width: 180px !important;
    max-width: 180px !important;
    flex: 0 0 auto !important;
  }
  .elib-header .elib-header-right .elib-actions .search-box:focus-within {
    width: 220px !important;
    max-width: 220px !important;
  }
  .elib-content {
    padding: 0.75rem;
  }
  .elib-content .elib-scroll-area {
    max-height: calc(100vh - 170px);
  }
  .elib-content .elib-tile-view,
  .elib-content .elib-dashboard {
    gap: 0.65rem;
  }
  .modal-container {
    width: 85%;
    max-width: 600px;
  }
  .upload-modal {
    width: 85%;
    max-width: 700px;
  }
  .more-user-modal .modern-modal {
    max-width: 500px;
    width: 90%;
  }
  .modal-body {
    padding: 1.25rem;
  }
  .modal-footer {
    padding: 0.9rem 1.25rem;
  }
}
@media (max-width: 766px) {
  .elib-content {
    padding: 0.5rem;
  }
  .elib-content .elib-scroll-area {
    max-height: calc(100vh - 200px);
  }
  .elib-content .elib-tile-view,
  .elib-content .elib-dashboard {
    gap: 0.5rem;
  }
}
@media (max-width: 576px) {
  .elib-container {
    border-radius: 0;
    box-shadow: none;
  }
  .elib-content {
    padding: 0.25rem;
  }
  .elib-content .elib-scroll-area {
    max-height: calc(100vh - 180px);
  }
}
/* Overlay and container */
.modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(17, 24, 39, 0.6);
  -webkit-backdrop-filter: blur(4px);
          backdrop-filter: blur(4px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1050;
}

.modal-container {
  background: #ffffff;
  border-radius: 16px;
  width: 550px;
  max-height: 90vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  box-shadow: 0 12px 30px rgba(0, 0, 0, 0.15);
  animation: slideIn 0.3s ease-out;
}
@media (min-width: 767px) and (max-width: 956px) {
  .modal-container {
    width: 85% !important;
    max-width: 600px !important;
    max-height: 92vh !important;
    border-radius: 14px !important;
  }
}
@media (max-width: 766px) {
  .modal-container {
    width: 95%;
    max-width: 95%;
    max-height: 95vh;
    border-radius: 12px;
  }
}
@media (max-width: 480px) {
  .modal-container {
    width: 100%;
    max-width: 100%;
    max-height: 100vh;
    border-radius: 0;
    margin: 0;
  }
}

@keyframes slideIn {
  from {
    opacity: 0;
    transform: translateY(-20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
/* Header */
.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: linear-gradient(135deg, #1571b9, #4c8dff);
  border-bottom: 1px solid #e5e7eb;
  padding: 1rem 1.5rem;
}
.modal-header h3 {
  margin: 0;
  font-weight: 600;
  color: #fff;
  font-size: 1.1rem;
}
.modal-header .close-btn {
  background: transparent;
  border: none;
  font-size: 1.2rem;
  color: #fff;
  cursor: pointer;
  transition: color 0.2s;
  min-width: 44px;
  min-height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
}
.modal-header .close-btn:hover {
  background: rgba(255, 255, 255, 0.1);
  color: #fff;
}
@media (max-width: 480px) {
  .modal-header {
    padding: 0.75rem 1rem;
  }
  .modal-header h3 {
    font-size: 1rem;
  }
  .modal-header .close-btn {
    min-width: 40px;
    min-height: 40px;
    font-size: 1.1rem;
  }
}

/* Body */
.modal-body {
  padding: 1.5rem;
  overflow-y: auto;
  flex: 1;
}
@media (min-width: 767px) and (max-width: 956px) {
  .modal-body {
    padding: 1.25rem !important;
  }
}
@media (max-width: 766px) {
  .modal-body {
    padding: 1rem;
  }
}
@media (max-width: 480px) {
  .modal-body {
    padding: 0.75rem;
  }
}

.form-group {
  margin-bottom: 1.25rem;
}
.form-group label {
  font-weight: 500;
  display: block;
  margin-bottom: 0.5rem;
  color: #374151;
  font-size: 0.95rem;
}
.form-group .required {
  color: #ef4444;
}
.form-group .input-control,
.form-group .textarea-control,
.form-group .select-control {
  width: 100%;
  padding: 0.65rem 0.8rem;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  font-size: 0.95rem;
  transition: border-color 0.2s, box-shadow 0.2s;
  min-height: 44px;
}
.form-group .input-control:focus,
.form-group .textarea-control:focus,
.form-group .select-control:focus {
  outline: none;
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.15);
}
.form-group .textarea-control {
  min-height: 80px;
  resize: vertical;
}
@media (min-width: 767px) and (max-width: 956px) {
  .form-group {
    margin-bottom: 1.15rem !important;
  }
  .form-group label {
    font-size: 0.93rem !important;
  }
  .form-group .input-control,
  .form-group .textarea-control,
  .form-group .select-control {
    font-size: 0.93rem !important;
    padding: 0.63rem 0.78rem !important;
  }
}
@media (max-width: 480px) {
  .form-group {
    margin-bottom: 1rem;
  }
  .form-group label {
    font-size: 0.9rem;
  }
  .form-group .input-control,
  .form-group .textarea-control,
  .form-group .select-control {
    font-size: 0.9rem;
    padding: 0.6rem 0.75rem;
  }
}

.label-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 0.5rem;
}
@media (min-width: 767px) and (max-width: 956px) {
  .label-row {
    gap: 0.6rem !important;
  }
  .label-row .add-user-btn {
    padding: 0.45rem 0.85rem !important;
    font-size: 0.88rem !important;
  }
}
@media (max-width: 480px) {
  .label-row {
    flex-direction: column;
    align-items: flex-start;
  }
  .label-row label {
    width: 100%;
  }
  .label-row .add-user-btn {
    width: 100%;
    justify-content: center;
  }
}

/* Buttons */
.btn {
  padding: 0.6rem 1.2rem;
  border-radius: 8px;
  font-weight: 500;
  cursor: pointer;
  border: none;
  transition: background 0.2s, color 0.2s, transform 0.1s;
}
.btn.primary {
  background: #3b82f6;
  color: white;
}
.btn.primary:disabled {
  background: #93c5fd;
  cursor: not-allowed;
}
.btn.primary:hover:not(:disabled) {
  background: #2563eb;
}
.btn.outline {
  background: transparent;
  border: 1px solid #d1d5db;
  color: #374151;
}
.btn.outline:hover {
  background: #f3f4f6;
}
.btn.small {
  padding: 0.4rem 0.8rem;
  font-size: 0.85rem;
}

.icon-btn {
  border: none;
  background: none;
  cursor: pointer;
  color: #6b7280;
  transition: color 0.2s;
}
.icon-btn:hover {
  color: #111827;
}
.icon-btn.danger:hover {
  color: #dc2626;
}

/* User List */
.user-list {
  background: #f9fafb;
  border-radius: 8px;
  padding: 0.5rem;
  max-height: 220px;
  overflow-y: auto;
  border: 1px solid #e5e7eb;
}
.user-list .user-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.6rem 0.75rem;
  border-bottom: 1px solid #e5e7eb;
  min-height: 44px;
}
.user-list .user-item:last-child {
  border-bottom: none;
}
.user-list .user-item .user-info {
  display: flex;
  align-items: center;
  gap: 0.6rem;
  flex: 1;
  min-width: 0;
}
.user-list .user-item .user-info .avatar {
  width: 30px;
  height: 30px;
  background: #e0e7ff;
  color: #3b82f6;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.user-list .user-item .user-info .user-name {
  font-size: 0.95rem;
  color: #374151;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.user-list .user-item .icon-btn {
  min-width: 44px;
  min-height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
}
@media (max-width: 480px) {
  .user-list .user-item {
    padding: 0.5rem;
    min-height: 40px;
  }
  .user-list .user-item .user-info .avatar {
    width: 28px;
    height: 28px;
    font-size: 0.9rem;
  }
  .user-list .user-item .user-info .user-name {
    font-size: 0.9rem;
  }
  .user-list .user-item .icon-btn {
    min-width: 40px;
    min-height: 40px;
  }
}
@media (max-width: 480px) {
  .user-list {
    max-height: 200px;
    padding: 0.4rem;
  }
}

/* Footer */
.modal-footer {
  padding: 1rem 1.5rem;
  border-top: 1px solid #e5e7eb;
  display: flex;
  justify-content: flex-end;
  gap: 0.8rem;
  background: #f9fafb;
  flex-wrap: wrap;
}
@media (min-width: 767px) and (max-width: 956px) {
  .modal-footer {
    padding: 0.9rem 1.25rem !important;
    gap: 0.65rem !important;
  }
}
@media (max-width: 766px) {
  .modal-footer {
    padding: 0.75rem 1rem;
    gap: 0.5rem;
  }
}
@media (max-width: 480px) {
  .modal-footer {
    padding: 0.75rem;
    flex-direction: column-reverse;
    gap: 0.5rem;
  }
  .modal-footer .btn {
    width: 100%;
    min-height: 44px;
  }
}

.upload-modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(20, 20, 20, 0.55);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1050;
  -webkit-backdrop-filter: blur(4px);
          backdrop-filter: blur(4px);
}

.upload-modal {
  background: #fff;
  width: 80%;
  max-width: 100%;
  border-radius: 6px;
  box-shadow: 0 12px 30px rgba(0, 0, 0, 0.15);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  animation: fadeInUp 0.25s ease-out;
  max-height: 90vh;
}
@media (min-width: 767px) and (max-width: 956px) {
  .upload-modal {
    width: 85% !important;
    max-width: 700px !important;
    max-height: 92vh !important;
  }
}
@media (max-width: 766px) {
  .upload-modal {
    width: 95%;
    max-height: 95vh;
  }
}
@media (max-width: 480px) {
  .upload-modal {
    width: 100%;
    max-width: 100%;
    max-height: 100vh;
    border-radius: 0;
    margin: 0;
  }
}

.upload-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: linear-gradient(135deg, #1571b9, #5b9dff);
  color: #fff;
  padding: 1rem 1.5rem;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  order: 0;
}
.upload-header .fa-solid,
.upload-header .fa {
  color: #fff !important;
}
.upload-header .upload-header-left {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}
.upload-header .upload-header-left .upload-icon {
  background: rgba(255, 255, 255, 0.15);
  width: 44px;
  height: 44px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.upload-header .upload-header-left .upload-icon i {
  font-size: 1.4rem;
}
.upload-header .upload-header-left .upload-group-info .upload-title {
  font-size: 1.2rem;
  font-weight: 600;
  margin: 0;
}
.upload-header .upload-header-left .upload-group-info .upload-subtitle {
  font-size: 0.9rem;
  opacity: 0.85;
  margin-top: 2px;
}
.upload-header .upload-close-btn {
  background: transparent;
  border: none;
  color: #fff;
  font-size: 1.3rem;
  cursor: pointer;
  transition: transform 0.2s ease;
  min-width: 44px;
  min-height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
}
.upload-header .upload-close-btn:hover {
  background: rgba(255, 255, 255, 0.1);
  transform: scale(1.1);
}
@media (min-width: 767px) and (max-width: 956px) {
  .upload-header {
    padding: 0.9rem 1.2rem !important;
  }
  .upload-header .upload-header-left {
    gap: 0.65rem !important;
  }
  .upload-header .upload-header-left .upload-icon {
    width: 40px !important;
    height: 40px !important;
  }
  .upload-header .upload-header-left .upload-icon i {
    font-size: 1.3rem !important;
  }
  .upload-header .upload-header-left .upload-group-info .upload-title {
    font-size: 1.1rem !important;
  }
  .upload-header .upload-header-left .upload-group-info .upload-subtitle {
    font-size: 0.85rem !important;
  }
  .upload-header .upload-close-btn {
    min-width: 42px !important;
    min-height: 42px !important;
    font-size: 1.2rem !important;
  }
}
@media (max-width: 480px) {
  .upload-header {
    padding: 0.75rem 1rem;
  }
  .upload-header .upload-header-left {
    gap: 0.5rem;
  }
  .upload-header .upload-header-left .upload-icon {
    width: 36px;
    height: 36px;
  }
  .upload-header .upload-header-left .upload-icon i {
    font-size: 1.2rem;
  }
  .upload-header .upload-header-left .upload-group-info .upload-title {
    font-size: 1rem;
  }
  .upload-header .upload-header-left .upload-group-info .upload-subtitle {
    font-size: 0.8rem;
  }
  .upload-header .upload-close-btn {
    min-width: 40px;
    min-height: 40px;
    font-size: 1.1rem;
  }
}

.upload-body {
  background: #f9fafb;
  flex: 1;
  overflow-y: auto;
}
.upload-body .upload-shell {
  border: 2px dashed #cfd8dc;
  border-radius: 12px;
  background: #fff;
  padding: 1.25rem;
  text-align: center;
  transition: border-color 0.3s;
}
.upload-body .upload-shell:hover {
  border-color: #1571b9;
}

.upload-footer {
  display: flex;
  justify-content: flex-end;
  padding: 1rem 1.5rem;
  background: #fff;
  border-top: 1px solid #eee;
  gap: 0.5rem;
}
.upload-footer .btn-cancel {
  background: #f3f4f6;
  border: none;
  color: #333;
  padding: 0.6rem 1.2rem;
  border-radius: 8px;
  cursor: pointer;
  font-weight: 500;
  transition: background 0.2s;
}
.upload-footer .btn-cancel:hover {
  background: #e0e0e0;
}

@keyframes fadeInUp {
  from {
    transform: translateY(25px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}
.modal {
  z-index: 99999;
}

.more-user-modal .modern-modal {
  border-radius: 12px;
  overflow: hidden;
  background: #fff;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.15);
  max-width: 420px;
  width: 95%;
  margin: auto;
  transition: all 0.3s ease;
  z-index: 9999;
  max-height: 90vh;
  display: flex;
  flex-direction: column;
}
@media (min-width: 767px) and (max-width: 956px) {
  .more-user-modal .modern-modal {
    max-width: 500px !important;
    width: 90% !important;
    max-height: 92vh !important;
  }
}
@media (max-width: 766px) {
  .more-user-modal .modern-modal {
    max-width: 95%;
    width: 95%;
    max-height: 95vh;
  }
}
@media (max-width: 480px) {
  .more-user-modal .modern-modal {
    width: 100%;
    max-width: 100%;
    margin: 0;
    border-radius: 0;
    max-height: 100vh;
  }
}
.more-user-modal .modern-modal-head {
  background: linear-gradient(135deg, #1571b9, #4c8dff);
  color: #fff;
  padding: 1rem 1.2rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  order: 0;
}
.more-user-modal .modern-modal-head .modal-title {
  font-weight: 600;
  font-size: 1.1rem;
  display: flex;
  align-items: center;
  gap: 8px;
}
.more-user-modal .modern-modal-head .delete {
  background: transparent;
  color: #fff;
  opacity: 0.8;
  transition: 0.2s;
}
.more-user-modal .modern-modal-head .delete:hover {
  opacity: 1;
}
.more-user-modal .modern-modal-body {
  padding: 1rem 1.2rem;
  background: #f9fafc;
  max-height: 60vh;
  overflow-y: auto;
  flex: 1;
}
@media (min-width: 767px) and (max-width: 956px) {
  .more-user-modal .modern-modal-body {
    padding: 0.9rem 1.1rem !important;
    max-height: 62vh !important;
  }
}
@media (max-width: 766px) {
  .more-user-modal .modern-modal-body {
    padding: 0.75rem 1rem;
    max-height: 65vh;
  }
}
@media (max-width: 480px) {
  .more-user-modal .modern-modal-body {
    padding: 0.75rem;
    max-height: calc(100vh - 200px);
  }
}
.more-user-modal .modern-modal-body .search-container {
  margin-bottom: 1rem;
}
.more-user-modal .modern-modal-body .search-container .search-input {
  border-radius: 8px;
  border: 1px solid #dcdcdc;
  transition: 0.2s;
}
.more-user-modal .modern-modal-body .search-container .search-input:focus {
  border-color: #1571b9;
  box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.15);
}
.more-user-modal .modern-modal-body .search-container .clear-icon {
  cursor: pointer;
  color: #999;
}
.more-user-modal .modern-modal-body .search-container .clear-icon:hover {
  color: #333;
}
.more-user-modal .modern-modal-body .select-all-container {
  margin-bottom: 0.75rem;
  padding-bottom: 0.75rem;
  border-bottom: 1px solid #e0e0e0;
}
.more-user-modal .modern-modal-body .select-all-container .select-all-item {
  display: flex;
  align-items: center;
  gap: 12px;
  border-radius: 8px;
  padding: 0.75rem;
  cursor: pointer;
  transition: all 0.25s ease;
  min-height: 44px;
  background: #f5f7fa;
}
.more-user-modal .modern-modal-body .select-all-container .select-all-item:hover {
  background: #eef5ff;
}
.more-user-modal .modern-modal-body .select-all-container .select-all-item.active {
  background: #dceeff;
  border-left: 3px solid #1571b9;
}
.more-user-modal .modern-modal-body .select-all-container .select-all-item .user-avatar {
  background: #e8f0fe;
  border-radius: 50%;
  width: 38px;
  height: 38px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #1571b9;
  font-size: 1.2rem;
  flex-shrink: 0;
}
.more-user-modal .modern-modal-body .select-all-container .select-all-item .user-name {
  flex: 1;
  font-weight: 600;
  color: #333;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.more-user-modal .modern-modal-body .select-all-container .select-all-item .check-icon {
  color: #1571b9;
  font-size: 1.2rem;
  flex-shrink: 0;
}
.more-user-modal .modern-modal-body .user-list .user-item {
  display: flex;
  align-items: center;
  gap: 12px;
  border-radius: 8px;
  padding: 0.75rem;
  margin-bottom: 0.5rem;
  cursor: pointer;
  transition: all 0.25s ease;
  min-height: 44px;
}
.more-user-modal .modern-modal-body .user-list .user-item:hover {
  background: #eef5ff;
}
.more-user-modal .modern-modal-body .user-list .user-item.active {
  background: #dceeff;
  border-left: 3px solid #1571b9;
}
.more-user-modal .modern-modal-body .user-list .user-item .user-avatar {
  background: #e8f0fe;
  border-radius: 50%;
  width: 38px;
  height: 38px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #1571b9;
  font-size: 1.2rem;
  flex-shrink: 0;
}
.more-user-modal .modern-modal-body .user-list .user-item .user-name {
  flex: 1;
  font-weight: 500;
  color: #333;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.more-user-modal .modern-modal-body .user-list .user-item .check-icon {
  color: #1571b9;
  font-size: 1.2rem;
  flex-shrink: 0;
}
@media (min-width: 767px) and (max-width: 956px) {
  .more-user-modal .modern-modal-body .user-list .user-item {
    padding: 0.7rem !important;
    gap: 11px !important;
    min-height: 42px !important;
  }
  .more-user-modal .modern-modal-body .user-list .user-item .user-avatar {
    width: 36px !important;
    height: 36px !important;
    font-size: 1.1rem !important;
  }
  .more-user-modal .modern-modal-body .user-list .user-item .user-name {
    font-size: 0.93rem !important;
  }
  .more-user-modal .modern-modal-body .user-list .user-item .check-icon {
    font-size: 1.1rem !important;
  }
}
@media (max-width: 480px) {
  .more-user-modal .modern-modal-body .user-list .user-item {
    padding: 0.6rem;
    gap: 10px;
    min-height: 40px;
  }
  .more-user-modal .modern-modal-body .user-list .user-item .user-avatar {
    width: 32px;
    height: 32px;
    font-size: 1rem;
  }
  .more-user-modal .modern-modal-body .user-list .user-item .user-name {
    font-size: 0.9rem;
  }
  .more-user-modal .modern-modal-body .user-list .user-item .check-icon {
    font-size: 1rem;
  }
}
.more-user-modal .modern-modal-foot {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #fff;
  padding: 0.75rem 1.2rem;
  border-top: 1px solid #eee;
  flex-wrap: wrap;
  gap: 0.5rem;
}
.more-user-modal .modern-modal-foot .button {
  border-radius: 8px;
  font-weight: 500;
  transition: 0.2s ease-in-out;
  min-height: 44px;
}
.more-user-modal .modern-modal-foot .clear-btn {
  color: #6c757d;
}
.more-user-modal .modern-modal-foot .clear-btn:hover {
  background: #f3f3f3;
}
.more-user-modal .modern-modal-foot .cancel-btn {
  background: #f3f3f3;
  color: #333;
}
.more-user-modal .modern-modal-foot .cancel-btn:hover {
  background: #e9e9e9;
}
.more-user-modal .modern-modal-foot .add-btn {
  background: #1571b9;
  color: #fff;
}
.more-user-modal .modern-modal-foot .add-btn:hover {
  background: #1571b9;
}
@media (min-width: 767px) and (max-width: 956px) {
  .more-user-modal .modern-modal-foot {
    padding: 0.85rem 1.1rem !important;
    gap: 0.6rem !important;
  }
  .more-user-modal .modern-modal-foot .button {
    min-height: 42px !important;
    padding: 0.5rem 1rem !important;
  }
}
@media (max-width: 480px) {
  .more-user-modal .modern-modal-foot {
    padding: 0.75rem;
    flex-direction: column-reverse;
  }
  .more-user-modal .modern-modal-foot .button {
    width: 100%;
  }
  .more-user-modal .modern-modal-foot .button-group {
    width: 100%;
    display: flex;
    gap: 0.5rem;
  }
  .more-user-modal .modern-modal-foot .button-group .button {
    flex: 1;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/components/elibraryandcourse/e-library/e-library-details/e-library-details.component.scss"],"names":[],"mappings":"AAi9BA;EACE,gBAAA;EACA,qBAAA;EACA,mBAAA;EACA,yCAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,eAAA;AAh9BF;AAk9BE;EACE,aAAA;EACA,mBAAA;EACA,YAAA;AAh9BJ;AAk9BI;EACE,mBAAA;EACA,cAAA;EACA,kBAAA;EACA,sBAAA;EACA,eAAA;EACA,yBAAA;EACA,iBAAA;AAh9BN;AAk9BM;EACE,mBAAA;EACA,cAAA;AAh9BR;AAo9BI;EACE,aAAA;EACA,sBAAA;AAl9BN;AAo9BM;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,SAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AAl9BR;AAq9BM;EACE,kBAAA;EACA,cAAA;AAn9BR;AAw9BE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;AAt9BJ;AAw9BI;EACE,kBAAA;AAt9BN;AAw9BM;EACE,kCAAA;EACA,kBAAA;EACA,yBAAA;EACA,iBAAA;EACA,oBAAA;AAt9BR;AAw9BQ;EACE,aAAA;EACA,qBAAA;EACA,6CAAA;AAt9BV;AA09BM;EACE,kBAAA;EACA,SAAA;EACA,QAAA;EACA,cAAA;EACA,iBAAA;AAx9BR;AA29BM;EACE,kBAAA;EACA,UAAA;EACA,QAAA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;AAz9BR;AA29BQ;EACE,cAAA;AAz9BV;AA89BI;EACE,aAAA;EACA,WAAA;AA59BN;AA89BM;EACE,yBAAA;EACA,mBAAA;EACA,kBAAA;EACA,sBAAA;EACA,eAAA;EACA,yBAAA;AA59BR;AA89BQ;EACE,mBAAA;AA59BV;AA+9BQ;EACE,mBAAA;EACA,WAAA;EACA,qBAAA;AA79BV;AAg+BQ;EACE,iBAAA;AA99BV;AAm+BI;EACE,aAAA;EACA,WAAA;AAj+BN;AAq+BM;EACE,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;EACA,wBAAA;EACA,eAAA;EACA,yBAAA;AAn+BR;AAq+BQ;EACE,kBAAA;AAn+BV;AAs+BQ;EACE,mBAAA;EACA,WAAA;AAp+BV;AAs+BU;EACE,mBAAA;AAp+BZ;AAw+BY;EADF;IAEI,aAAA;EAr+BZ;AACF;AAy+BQ;EACE,mBAAA;EACA,WAAA;AAv+BV;AAy+BU;EACE,mBAAA;AAv+BZ;;AA++BA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,mBAAA;EACA,gCAAA;EACA,qBAAA;EACA,yCAAA;EACA,gBAAA;EACA,MAAA;EACA,WAAA;EA+LA,eAAA;AA1qCF;AA6+BE;EACE,aAAA;EACA,mBAAA;EACA,YAAA;AA3+BJ;AA6+BI;EACE,mBAAA;EACA,YAAA;EACA,kBAAA;EACA,sBAAA;EACA,eAAA;EACA,yBAAA;AA3+BN;AA6+BM;EACE,mBAAA;AA3+BR;AA8+BM;EACE,iBAAA;EACA,WAAA;AA5+BR;AAg/BI;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;AA9+BN;AAg/BM;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,SAAA;AA9+BR;AAi/BM;EACE,iBAAA;EACA,WAAA;AA/+BR;AAm/BI;EACE,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,YAAA;EACA,SAAA;EACA,UAAA;AAj/BN;AAm/BM;EACE,yBAAA;EACA,kBAAA;EACA,sBAAA;EACA,eAAA;EACA,yBAAA;EACA,mBAAA;AAj/BR;AAo/BM;EACE,eAAA;EACA,eAAA;EACA,kBAAA;EACA,2BAAA;AAl/BR;AAo/BQ;EACE,mBAAA;AAl/BV;AAq/BQ;EACE,UAAA;EACA,uBAAA;AAn/BV;AAq/BU;EACE,uBAAA;AAn/BZ;AAu/BQ;EACE,iBAAA;EACA,WAAA;AAr/BV;AAw/BQ;EACE,WAAA;AAt/BV;AAy/BQ;EACE,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAv/BV;AAy/BU;EACE,mBAAA;EACA,qBAAA;AAv/BZ;AA0/BU;EACE,WAAA;EACA,YAAA;EACA,cAAA;AAx/BZ;AA+/BE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AA7/BJ;AAigCI;EACE,aAAA;EACA,mBAAA;EACA,YAAA;AA//BN;AAigCM;EACE,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,sBAAA;EACA,eAAA;EACA,yBAAA;AA//BR;AAigCQ;EACE,mBAAA;AA//BV;AAkgCQ;EACE,cAAA;EACA,eAAA;AAhgCV;AAogCM;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,yBAAA;EACA,mBAAA;EACA,sBAAA;AAlgCR;AAsgCQ;EAEE,qBAAA;AArgCV;AAwgCQ;EACE,YAAA;EACA,uBAAA;EACA,aAAA;EACA,OAAA;EACA,iBAAA;EACA,WAAA;AAtgCV;AAygCQ;;EAEE,WAAA;EACA,kBAAA;AAvgCV;AA0gCQ;EACE,oBAAA;AAxgCV;AA2gCQ;EACE,eAAA;EACA,cAAA;AAzgCV;AA2gCU;EACE,WAAA;AAzgCZ;AAihCE;EA1MF;IA2MI,eAAA;IACA,YAAA;IACA,uBAAA;EA9gCF;EAghCE;IACE,WAAA;IACA,8BAAA;IACA,eAAA;IACA,WAAA;EA9gCJ;EAghCI;IACE,OAAA;IACA,YAAA;EA9gCN;EAghCM;IACE,iBAAA;IACA,eAAA;IACA,gBAAA;IACA,uBAAA;IACA,mBAAA;EA9gCR;EAihCM;IACE,iBAAA;EA/gCR;EAmhCI;IACE,WAAA;EAjhCN;EAqhCM;IACE,eAAA;IACA,eAAA;IACA,gBAAA;IACA,aAAA;IACA,mBAAA;IACA,uBAAA;EAnhCR;EAqhCQ;IACE,UAAA;IACA,eAAA;IACA,gBAAA;EAnhCV;EAshCQ;IACE,WAAA;EAphCV;EAuhCQ;IACE,eAAA;IACA,gBAAA;IACA,eAAA;EArhCV;EAuhCU;IACE,WAAA;EArhCZ;EA4hCE;IACE,WAAA;IACA,8BAAA;IACA,eAAA;IACA,WAAA;EA1hCJ;EA4hCI;IACE,WAAA;IACA,eAAA;IACA,WAAA;EA1hCN;EA4hCM;IACE,eAAA;IACA,gBAAA;IACA,eAAA;IACA,kBAAA;EA1hCR;EA4hCQ;IACE,iBAAA;EA1hCV;EA8hCM;IACE,WAAA;IACA,eAAA;IACA,OAAA;IACA,YAAA;EA5hCR;EA8hCQ;IACE,WAAA;EA5hCV;AACF;AAkiCE;EA9SF;IA+SI,eAAA;EA/hCF;EAkiCI;IACE,eAAA;IACA,gBAAA;IACA,eAAA;EAhiCN;EAoiCM;IACE,kBAAA;EAliCR;EAqiCM;IACE,kBAAA;EAniCR;EAuiCI;IACE,WAAA;EAriCN;EAuiCM;IACE,gBAAA;IACA,eAAA;IACA,gBAAA;EAriCR;EAuiCQ;IACE,UAAA;IACA,eAAA;IACA,gBAAA;EAriCV;EAwiCQ;IACE,WAAA;EAtiCV;EAyiCQ;IACE,eAAA;IACA,gBAAA;IACA,eAAA;EAviCV;EAyiCU;IACE,WAAA;EAviCZ;EAgjCM;IACE,iBAAA;IACA,sBAAA;EA9iCR;EAgjCQ;IACE,kBAAA;EA9iCV;AACF;;AAqjCA;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;EACA,YAAA;EAGA,gBAAA;AApjCF;AAujCE;EACE,OAAA;EACA,aAAA;EACA,sBAAA;EACA,aAAA;AArjCJ;AAujCI;EACE,YAAA;EACA,uCAAA;EACA,+BAAA;EACA,uCAAA;EACA,gBAAA;EACA,kBAAA;EACA,uBAAA;AArjCN;AAujCM;EACE,UAAA;AArjCR;AAwjCM;EACE,mBAAA;EACA,kBAAA;AAtjCR;AAyjCM;EACE,mBAAA;AAvjCR;AA2jCI;;EAGE,eAAA;EACA,SAAA;EACA,gCAAA;AA1jCN;AA4jCM;;;;EAEE,WAAA;EACA,gBAAA;EACA,sBAAA;EACA,yCAAA;EACA,qDAAA;AAxjCR;AA0jCQ;;;;EACE,2BAAA;EACA,yCAAA;AArjCV;;AA4jCA,oCAAA;AACA;EACE;IACE,eAAA;EAzjCF;EA2jCE;;IAEE,YAAA;EAzjCJ;AACF;AA6jCA,qEAAA;AACA;EACE;IACE,kCAAA;IACA,4BAAA;IACA,wBAAA;IACA,8BAAA;EA3jCF;EA6jCE;IACE,yBAAA;IACA,uBAAA;IACA,sBAAA;IACA,uBAAA;IACA,sCAAA;IACA,4BAAA;IACA,wBAAA;IACA,8BAAA;EA3jCJ;EA6jCI;IACE,yBAAA;IACA,0BAAA;IACA,2BAAA;EA3jCN;EA8jCI;IACE,yBAAA;IACA,uBAAA;IACA,2BAAA;EA5jCN;EA8jCM;IACE,6BAAA;IACA,2BAAA;IACA,2BAAA;IACA,kCAAA;IACA,8BAAA;EA5jCR;EA+jCM;IACE,6BAAA;EA7jCR;EAikCI;IACE,sBAAA;IACA,yBAAA;IACA,wBAAA;IACA,8BAAA;EA/jCN;EAikCM;IACE,0BAAA;IACA,0BAAA;IACA,2BAAA;IACA,wBAAA;IACA,8BAAA;IACA,kCAAA;EA/jCR;EAikCQ;IACE,sBAAA;IACA,uBAAA;EA/jCV;EAqkCE;IACE,yBAAA;IACA,sBAAA;IACA,uBAAA;IACA,oCAAA;IACA,4BAAA;IACA,wBAAA;IACA,8BAAA;EAnkCJ;EAqkCI;IACE,sBAAA;IACA,sBAAA;IACA,4BAAA;IACA,wBAAA;IACA,8BAAA;EAnkCN;EAqkCM;IACE,iCAAA;IACA,6BAAA;IACA,0BAAA;IACA,2BAAA;IACA,8BAAA;EAnkCR;EAqkCQ;IACE,4BAAA;EAnkCV;EAukCM;IACE,uBAAA;IACA,2BAAA;IACA,yBAAA;IACA,2BAAA;EArkCR;EAukCQ;IACE,uBAAA;IACA,2BAAA;EArkCV;EAwkCQ;IACE,6BAAA;EAtkCV;EA6kCA;IACE,2BAAA;EA3kCF;EA6kCE;IACE,0CAAA;EA3kCJ;EA8kCE;;IAEE,uBAAA;EA5kCJ;EAglCA;IACE,qBAAA;IACA,2BAAA;EA9kCF;EAilCA;IACE,qBAAA;IACA,2BAAA;EA/kCF;EAmlCE;IACE,2BAAA;IACA,qBAAA;EAjlCJ;EAqlCA;IACE,2BAAA;EAnlCF;EAslCA;IACE,kCAAA;EAplCF;AACF;AAulCA,gCAAA;AACA;EACE;IACE,kCAAA;IACA,4BAAA;EArlCF;EAulCE;IACE,kBAAA;IACA,uBAAA;IACA,sBAAA;IACA,uBAAA;IACA,sCAAA;IACA,4BAAA;EArlCJ;EAulCI;IACE,kBAAA;IACA,uBAAA;EArlCN;EAulCM;IACE,6BAAA;IACA,2BAAA;EArlCR;EAwlCM;IACE,6BAAA;EAtlCR;EA0lCI;IACE,sBAAA;EAxlCN;EA0lCM;IACE,2BAAA;IACA,0BAAA;IACA,2BAAA;EAxlCR;EA0lCQ;IACE,sBAAA;EAxlCV;EA8lCE;IACE,yBAAA;IACA,sBAAA;IACA,uBAAA;IACA,oCAAA;IACA,4BAAA;EA5lCJ;EA8lCI;IACE,sBAAA;IACA,uBAAA;IACA,4BAAA;EA5lCN;EA8lCM;IACE,mCAAA;IACA,6BAAA;IACA,0BAAA;IACA,2BAAA;EA5lCR;EA8lCQ;IACE,6BAAA;EA5lCV;EAgmCM;IACE,uBAAA;IACA,2BAAA;IACA,yBAAA;EA9lCR;EAgmCQ;IACE,uBAAA;IACA,2BAAA;EA9lCV;EAqmCA;IACE,gBAAA;EAnmCF;EAqmCE;IACE,+BAAA;EAnmCJ;EAsmCE;;IAEE,YAAA;EApmCJ;EAwmCA;IACE,UAAA;IACA,gBAAA;EAtmCF;EAymCA;IACE,UAAA;IACA,gBAAA;EAvmCF;EA2mCE;IACE,gBAAA;IACA,UAAA;EAzmCJ;EA6mCA;IACE,gBAAA;EA3mCF;EA8mCA;IACE,uBAAA;EA5mCF;AACF;AA+mCA;EACE;IACE,eAAA;EA7mCF;EA+mCE;IACE,+BAAA;EA7mCJ;EAgnCE;;IAEE,WAAA;EA9mCJ;AACF;AAknCA;EACE;IACE,gBAAA;IACA,gBAAA;EAhnCF;EAmnCA;IACE,gBAAA;EAjnCF;EAmnCE;IACE,+BAAA;EAjnCJ;AACF;AAqnCA,0BAAA;AACA;EACE,eAAA;EACA,QAAA;EACA,iCAAA;EACA,kCAAA;UAAA,0BAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;AAnnCF;;AAsnCA;EACE,mBAAA;EACA,mBAAA;EACA,YAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,2CAAA;EACA,gCAAA;AAnnCF;AAqnCE;EAXF;IAYI,qBAAA;IACA,2BAAA;IACA,2BAAA;IACA,8BAAA;EAlnCF;AACF;AAonCE;EAlBF;IAmBI,UAAA;IACA,cAAA;IACA,gBAAA;IACA,mBAAA;EAjnCF;AACF;AAmnCE;EAzBF;IA0BI,WAAA;IACA,eAAA;IACA,iBAAA;IACA,gBAAA;IACA,SAAA;EAhnCF;AACF;;AAmnCA;EACE;IACE,UAAA;IACA,4BAAA;EAhnCF;EAmnCA;IACE,UAAA;IACA,wBAAA;EAjnCF;AACF;AAonCA,WAAA;AACA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,qDAAA;EACA,gCAAA;EACA,oBAAA;AAlnCF;AAonCE;EACE,SAAA;EACA,gBAAA;EACA,WAAA;EACA,iBAAA;AAlnCJ;AAqnCE;EACE,uBAAA;EACA,YAAA;EACA,iBAAA;EACA,WAAA;EACA,eAAA;EACA,sBAAA;EACA,eAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;AAnnCJ;AAqnCI;EACE,oCAAA;EACA,WAAA;AAnnCN;AAunCE;EAnCF;IAoCI,qBAAA;EApnCF;EAsnCE;IACE,eAAA;EApnCJ;EAunCE;IACE,eAAA;IACA,gBAAA;IACA,iBAAA;EArnCJ;AACF;;AAynCA,SAAA;AACA;EACE,eAAA;EACA,gBAAA;EACA,OAAA;AAtnCF;AAwnCE;EALF;IAMI,2BAAA;EArnCF;AACF;AAunCE;EATF;IAUI,aAAA;EApnCF;AACF;AAsnCE;EAbF;IAcI,gBAAA;EAnnCF;AACF;;AAsnCA;EACE,sBAAA;AAnnCF;AAqnCE;EACE,gBAAA;EACA,cAAA;EACA,qBAAA;EACA,cAAA;EACA,kBAAA;AAnnCJ;AAsnCE;EACE,cAAA;AApnCJ;AAunCE;;;EAGE,WAAA;EACA,uBAAA;EACA,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,8CAAA;EACA,gBAAA;AArnCJ;AAunCI;;;EACE,aAAA;EACA,qBAAA;EACA,8CAAA;AAnnCN;AAunCE;EACE,gBAAA;EACA,gBAAA;AArnCJ;AAwnCE;EAtCF;IAuCI,iCAAA;EArnCF;EAunCE;IACE,6BAAA;EArnCJ;EAwnCE;;;IAGE,6BAAA;IACA,mCAAA;EAtnCJ;AACF;AAynCE;EArDF;IAsDI,mBAAA;EAtnCF;EAwnCE;IACE,iBAAA;EAtnCJ;EAynCE;;;IAGE,iBAAA;IACA,uBAAA;EAvnCJ;AACF;;AA2nCA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,eAAA;EACA,WAAA;AAxnCF;AA0nCE;EAPF;IAQI,sBAAA;EAvnCF;EAynCE;IACE,mCAAA;IACA,6BAAA;EAvnCJ;AACF;AA0nCE;EAhBF;IAiBI,sBAAA;IACA,uBAAA;EAvnCF;EAynCE;IACE,WAAA;EAvnCJ;EA0nCE;IACE,WAAA;IACA,uBAAA;EAxnCJ;AACF;;AA4nCA,YAAA;AACA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,YAAA;EACA,uDAAA;AAznCF;AA2nCE;EACE,mBAAA;EACA,YAAA;AAznCJ;AA2nCI;EACE,mBAAA;EACA,mBAAA;AAznCN;AA4nCI;EACE,mBAAA;AA1nCN;AA8nCE;EACE,uBAAA;EACA,yBAAA;EACA,cAAA;AA5nCJ;AA8nCI;EACE,mBAAA;AA5nCN;AAgoCE;EACE,sBAAA;EACA,kBAAA;AA9nCJ;;AAkoCA;EACE,YAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;EACA,sBAAA;AA/nCF;AAioCE;EACE,cAAA;AA/nCJ;AAkoCE;EACE,cAAA;AAhoCJ;;AAooCA,cAAA;AACA;EACE,mBAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,yBAAA;AAjoCF;AAmoCE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,uBAAA;EACA,gCAAA;EACA,gBAAA;AAjoCJ;AAmoCI;EACE,mBAAA;AAjoCN;AAooCI;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,OAAA;EACA,YAAA;AAloCN;AAooCM;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,cAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;AAloCR;AAqoCM;EACE,kBAAA;EACA,cAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AAnoCR;AAuoCI;EACE,eAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAroCN;AAwoCI;EAhDF;IAiDI,eAAA;IACA,gBAAA;EAroCJ;EAwoCM;IACE,WAAA;IACA,YAAA;IACA,iBAAA;EAtoCR;EAyoCM;IACE,iBAAA;EAvoCR;EA2oCI;IACE,eAAA;IACA,gBAAA;EAzoCN;AACF;AA6oCE;EA/EF;IAgFI,iBAAA;IACA,eAAA;EA1oCF;AACF;;AA6oCA,WAAA;AACA;EACE,oBAAA;EACA,6BAAA;EACA,aAAA;EACA,yBAAA;EACA,WAAA;EACA,mBAAA;EACA,eAAA;AA1oCF;AA4oCE;EATF;IAUI,kCAAA;IACA,uBAAA;EAzoCF;AACF;AA2oCE;EAdF;IAeI,qBAAA;IACA,WAAA;EAxoCF;AACF;AA0oCE;EAnBF;IAoBI,gBAAA;IACA,8BAAA;IACA,WAAA;EAvoCF;EAyoCE;IACE,WAAA;IACA,gBAAA;EAvoCJ;AACF;;AA2oCA;EACE,eAAA;EACA,QAAA;EACA,kCAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,kCAAA;UAAA,0BAAA;AAxoCF;;AA2oCA;EACE,gBAAA;EACA,UAAA;EACA,eAAA;EACA,kBAAA;EACA,2CAAA;EACA,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,kCAAA;EACA,gBAAA;AAxoCF;AA0oCE;EAZF;IAaI,qBAAA;IACA,2BAAA;IACA,2BAAA;EAvoCF;AACF;AAyoCE;EAlBF;IAmBI,UAAA;IACA,gBAAA;EAtoCF;AACF;AAwoCE;EAvBF;IAwBI,WAAA;IACA,eAAA;IACA,iBAAA;IACA,gBAAA;IACA,SAAA;EAroCF;AACF;;AAwoCA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,qDAAA;EACA,WAAA;EACA,oBAAA;EACA,iDAAA;EACA,QAAA;AAroCF;AAuoCE;;EAEE,sBAAA;AAroCJ;AAwoCE;EACE,aAAA;EACA,mBAAA;EACA,YAAA;AAtoCJ;AAwoCI;EACE,qCAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAtoCN;AAwoCM;EACE,iBAAA;AAtoCR;AA2oCM;EACE,iBAAA;EACA,gBAAA;EACA,SAAA;AAzoCR;AA4oCM;EACE,iBAAA;EACA,aAAA;EACA,eAAA;AA1oCR;AA+oCE;EACE,uBAAA;EACA,YAAA;EACA,WAAA;EACA,iBAAA;EACA,eAAA;EACA,+BAAA;EACA,eAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;AA7oCJ;AA+oCI;EACE,oCAAA;EACA,qBAAA;AA7oCN;AAipCE;EArEF;IAsEI,iCAAA;EA9oCF;EAgpCE;IACE,uBAAA;EA9oCJ;EAgpCI;IACE,sBAAA;IACA,uBAAA;EA9oCN;EAgpCM;IACE,4BAAA;EA9oCR;EAmpCM;IACE,4BAAA;EAjpCR;EAopCM;IACE,6BAAA;EAlpCR;EAupCE;IACE,0BAAA;IACA,2BAAA;IACA,4BAAA;EArpCJ;AACF;AAwpCE;EAtGF;IAuGI,qBAAA;EArpCF;EAupCE;IACE,WAAA;EArpCJ;EAupCI;IACE,WAAA;IACA,YAAA;EArpCN;EAupCM;IACE,iBAAA;EArpCR;EA0pCM;IACE,eAAA;EAxpCR;EA2pCM;IACE,iBAAA;EAzpCR;EA8pCE;IACE,eAAA;IACA,gBAAA;IACA,iBAAA;EA5pCJ;AACF;;AAgqCA;EAEE,mBAAA;EACA,OAAA;EACA,gBAAA;AA9pCF;AAgqCE;EACE,0BAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,6BAAA;AA9pCJ;AAgqCI;EACE,qBAAA;AA9pCN;;AAmqCA;EACE,aAAA;EACA,yBAAA;EACA,oBAAA;EACA,gBAAA;EACA,0BAAA;EACA,WAAA;AAhqCF;AAkqCE;EACE,mBAAA;EACA,YAAA;EACA,WAAA;EACA,sBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,2BAAA;AAhqCJ;AAkqCI;EACE,mBAAA;AAhqCN;;AAqqCA;EACE;IACE,2BAAA;IACA,UAAA;EAlqCF;EAqqCA;IACE,wBAAA;IACA,UAAA;EAnqCF;AACF;AAsqCA;EACE,cAAA;AApqCF;;AAwqCE;EACE,mBAAA;EACA,gBAAA;EACA,gBAAA;EACA,2CAAA;EACA,gBAAA;EACA,UAAA;EACA,YAAA;EACA,yBAAA;EACA,aAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;AArqCJ;AAuqCI;EAdF;IAeI,2BAAA;IACA,qBAAA;IACA,2BAAA;EApqCJ;AACF;AAsqCI;EApBF;IAqBI,cAAA;IACA,UAAA;IACA,gBAAA;EAnqCJ;AACF;AAqqCI;EA1BF;IA2BI,WAAA;IACA,eAAA;IACA,SAAA;IACA,gBAAA;IACA,iBAAA;EAlqCJ;AACF;AAqqCE;EACE,qDAAA;EACA,WAAA;EACA,oBAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,QAAA;AAnqCJ;AAqqCI;EACE,gBAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;AAnqCN;AAsqCI;EACE,uBAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;AApqCN;AAsqCM;EACE,UAAA;AApqCR;AAyqCE;EACE,oBAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBAAA;EACA,OAAA;AAvqCJ;AAyqCI;EAPF;IAQI,iCAAA;IACA,2BAAA;EAtqCJ;AACF;AAwqCI;EAZF;IAaI,qBAAA;IACA,gBAAA;EArqCJ;AACF;AAuqCI;EAjBF;IAkBI,gBAAA;IACA,+BAAA;EApqCJ;AACF;AAsqCI;EACE,mBAAA;AApqCN;AAsqCM;EACE,kBAAA;EACA,yBAAA;EACA,gBAAA;AApqCR;AAsqCQ;EACE,qBAAA;EACA,6CAAA;AApqCV;AAwqCM;EACE,eAAA;EACA,WAAA;AAtqCR;AAwqCQ;EACE,WAAA;AAtqCV;AA2qCI;EACE,sBAAA;EACA,uBAAA;EACA,gCAAA;AAzqCN;AA2qCM;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,0BAAA;EACA,gBAAA;EACA,mBAAA;AAzqCR;AA2qCQ;EACE,mBAAA;AAzqCV;AA4qCQ;EACE,mBAAA;EACA,8BAAA;AA1qCV;AA6qCQ;EACE,mBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,iBAAA;EACA,cAAA;AA3qCV;AA8qCQ;EACE,OAAA;EACA,gBAAA;EACA,WAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AA5qCV;AA+qCQ;EACE,cAAA;EACA,iBAAA;EACA,cAAA;AA7qCV;AAmrCM;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EAEA,kBAAA;EACA,gBAAA;EACA,qBAAA;EACA,eAAA;EACA,0BAAA;EACA,gBAAA;AAlrCR;AAqrCQ;EACE,mBAAA;AAnrCV;AAsrCQ;EACE,mBAAA;EACA,8BAAA;AAprCV;AAurCQ;EACE,mBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,iBAAA;EACA,cAAA;AArrCV;AAwrCQ;EACE,OAAA;EACA,gBAAA;EACA,WAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AAtrCV;AAyrCQ;EACE,cAAA;EACA,iBAAA;EACA,cAAA;AAvrCV;AA0rCQ;EAlDF;IAmDI,0BAAA;IACA,oBAAA;IACA,2BAAA;EAvrCR;EAyrCQ;IACE,sBAAA;IACA,uBAAA;IACA,4BAAA;EAvrCV;EA0rCQ;IACE,6BAAA;EAxrCV;EA2rCQ;IACE,4BAAA;EAzrCV;AACF;AA4rCQ;EAtEF;IAuEI,eAAA;IACA,SAAA;IACA,gBAAA;EAzrCR;EA2rCQ;IACE,WAAA;IACA,YAAA;IACA,eAAA;EAzrCV;EA4rCQ;IACE,iBAAA;EA1rCV;EA6rCQ;IACE,eAAA;EA3rCV;AACF;AAisCE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,0BAAA;EACA,eAAA;EACA,WAAA;AA/rCJ;AAisCI;EACE,kBAAA;EACA,gBAAA;EACA,4BAAA;EACA,gBAAA;AA/rCN;AAksCI;EACE,cAAA;AAhsCN;AAksCM;EACE,mBAAA;AAhsCR;AAosCI;EACE,mBAAA;EACA,WAAA;AAlsCN;AAosCM;EACE,mBAAA;AAlsCR;AAssCI;EACE,mBAAA;EACA,WAAA;AApsCN;AAssCM;EACE,mBAAA;AApsCR;AAwsCI;EA3CF;IA4CI,kCAAA;IACA,sBAAA;EArsCJ;EAusCI;IACE,2BAAA;IACA,+BAAA;EArsCN;AACF;AAwsCI;EArDF;IAsDI,gBAAA;IACA,8BAAA;EArsCJ;EAusCI;IACE,WAAA;EArsCN;EAwsCI;IACE,WAAA;IACA,aAAA;IACA,WAAA;EAtsCN;EAwsCM;IACE,OAAA;EAtsCR;AACF","sourcesContent":["// .top-box-shadow {\n//   /// box-shadow: none;\n// }\n\n// header {\n//   background: transparent !important;\n// }\n\n// .input {\n//   box-shadow: rgba(0, 0, 0, 0.02) 0px 1px 3px 0px, rgba(27, 31, 35, 0.02) 0px 0px 0px 1px !important;\n// }\n\n// .tabs {\n//   padding: .5rem 0rem;\n// }\n\n// select.form-select {\n//   box-shadow: rgba(0, 0, 0, 0.02) 0px 1px 3px 0px, rgba(27, 31, 35, 0.2) 0px 0px 0px 1px !important;\n//   color: #666;\n//   max-width: 170px;\n// }\n\n// .elibrary-filter {\n//   background: #fff;\n//   padding: 10px;\n\n//   .input {\n//     border-radius: 15px !important;\n//   }\n// }\n\n// .notification-content-wrapper {\n//   height: calc(100vh - 60px);\n//   overflow-y: auto;\n//   overflow-x: hidden;\n// }\n\n// .policy-upload {\n//   .modal-dialog {\n//     max-width: calc(100vw - 50px) !important;\n\n//     .modal-content {\n//       width: 100% !important;\n//     }\n\n//     .modal-body {\n//       padding: 0px !important;\n//     }\n\n//     ::ng-deep .card {\n//       box-shadow: none !important;\n//       height: calc(100vh - 110px) !important;\n\n//       .card-body {\n//         min-height: calc(100vh - 300px) !important;\n//       }\n//     }\n//   }\n// }\n\n// .modal-dialog {\n//   .modal-content {\n//     max-width: calc(100vw - 50px);\n//   }\n\n//   .modal-header {\n//     justify-content: space-between;\n//   }\n\n//   .modal-body {\n//     height: calc(100vh - 100px);\n//     overflow-y: auto;\n//     scrollbar-width: none;\n//     background: #fafafa !important;\n\n//     .field.pos-relative {\n//       background: #fff !important;\n//     }\n//   }\n\n//   .list-group {\n//     .user-icon {\n//       float: left;\n//       margin-right: 5px;\n\n//       .fa-solid {\n//         color: #bababa !important;\n//         margin-right: 10px;\n//       }\n//     }\n//   }\n\n//   .fa-solid {\n//     font-size: 1.5rem !important;\n//     color: #fff !important;\n//   }\n\n//   .btn-primary {\n//     background: var(--primaryColor) !important;\n//     color: #fff !important;\n//   }\n\n//   .btn-cancel {\n//     background-color: #eee;\n//     color: #111;\n//   }\n\n//   .btn {\n//     padding: .3rem .8rem !important;\n//   }\n// }\n\n// .modal.fade {\n//   background: rgba(0, 0, 0, 0.2);\n// }\n\n// .modal.show {\n//   display: block;\n// }\n\n// .modal-header {\n//   background: var(--primaryColor);\n//   color: #fff;\n// }\n\n// .modalMobileView {\n//   .modal-card-head {\n//     background: var(--primaryColor) !important;\n//     color: #fff;\n//   }\n\n\n//   .user-icon {\n//     float: left;\n\n//     .fa-solid {\n//       color: #bababa !important;\n//       margin-right: 10px;\n//     }\n//   }\n\n// }\n\n// .pi-cloud-upload {\n//   font-size: 1.5rem;\n// }\n\n// .editgroup-modal {\n//   .list-group {\n//     .pi-user {\n//       font-size: 1.2rem !important;\n//       margin-right: 5px !important;\n//     }\n\n//     .panel-block {\n//       padding: 0.75em !important;\n//     }\n\n//     .pi-trash {\n//       color: #c10909;\n//     }\n//   }\n// }\n\n// .more-user-modal {\n//   .panel {\n//     .user-icon {\n//       margin-right: 10px;\n//     }\n\n//     .panel-block:hover {\n//       background: var(--listbackgoundhover) !important;\n//       color: var(--listcolor) !important;\n//     }\n\n//     .panel-block.active {\n//       background: var(--listbackgoundhover) !important;\n//       color: var(--listcolor) !important;\n\n//       border-bottom: 1px solid #4bf768 !important;\n\n//       .fa-check {\n//         color: var(--listcolor) !important;\n//       }\n//     }\n//   }\n// }\n\n// .inline-icons {\n//   margin: 0px;\n//   padding: 0px;\n//   display: inline-flex;\n//   align-items: center;\n//   gap: 15px;\n\n// }\n\n// .custom-modal-overlay {\n//   position: fixed;\n//   top: 0;\n//   left: 0;\n//   width: 100%;\n//   height: 100%;\n//   background: rgba(10, 10, 10, 0.6);\n//   display: flex;\n//   align-items: center;\n//   justify-content: center;\n//   z-index: 1050;\n//   animation: fadeIn 0.3s ease-in-out;\n// }\n\n// .custom-modal {\n//   background: #fff;\n//   border-radius: 1rem;\n//   width: 550px;\n//   max-height: 90vh;\n//   overflow: hidden;\n//   display: flex;\n//   flex-direction: column;\n//   box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);\n//   animation: slideUp 0.4s ease;\n\n//   @media (max-width: 600px) {\n//     width: 90%;\n//   }\n// }\n\n// .modal-header {\n//   background: linear-gradient(135deg, #1571b9, #00a6ff);\n//   color: #fff;\n//   padding: 1rem 1.5rem;\n//   display: flex;\n//   justify-content: space-between;\n//   align-items: center;\n\n//   .modal-title {\n//     font-size: 1.25rem;\n//     font-weight: 600;\n//   }\n\n//   .close-btn {\n//     background: transparent;\n//     border: none;\n//     color: #fff;\n//     cursor: pointer;\n//     font-size: 1.2rem;\n//     transition: 0.2s;\n\n//     &:hover {\n//       color: #ffdfdf;\n//       transform: scale(1.1);\n//     }\n//   }\n// }\n\n// .modal-body {\n//   padding: 1.5rem;\n//   overflow-y: auto;\n//   flex: 1;\n// }\n\n// .form-group {\n//   margin-bottom: 1.2rem;\n\n//   label {\n//     display: block;\n//     font-weight: 600;\n//     margin-bottom: 0.3rem;\n//   }\n\n//   .required {\n//     color: #e74c3c;\n//   }\n\n//   .input-field,\n//   .select-field,\n//   .textarea-field {\n//     width: 100%;\n//     padding: 0.6rem 0.8rem;\n//     border: 1px solid #ddd;\n//     border-radius: 0.5rem;\n//     font-size: 0.95rem;\n//     transition: all 0.2s ease;\n\n//     &:focus {\n//       outline: none;\n//       border-color: #1571b9;\n//       box-shadow: 0 0 0 2px rgba(0, 122, 217, 0.15);\n//     }\n//   }\n// }\n\n// .label-row {\n//   display: flex;\n//   justify-content: space-between;\n//   align-items: center;\n// }\n\n// .add-user-btn {\n//   background: #1571b9;\n//   color: white;\n//   border: none;\n//   padding: 0.4rem 0.8rem;\n//   border-radius: 0.4rem;\n//   cursor: pointer;\n//   font-size: 0.85rem;\n//   display: flex;\n//   align-items: center;\n//   gap: 0.3rem;\n\n//   &:disabled {\n//     opacity: 0.6;\n//     cursor: not-allowed;\n//   }\n\n//   &:hover {\n//     background: #1571b9;\n//   }\n// }\n\n// .selected-count {\n//   font-size: 0.85rem;\n//   color: #555;\n//   margin-top: 0.3rem;\n// }\n\n// .user-list {\n//   border: 1px solid #ddd;\n//   border-radius: 0.6rem;\n//   padding: 0.5rem;\n//   max-height: 220px;\n//   overflow-y: auto;\n//   background: #fafafa;\n\n//   .user-item {\n//     display: flex;\n//     justify-content: space-between;\n//     align-items: center;\n//     padding: 0.5rem 0.7rem;\n//     border-bottom: 1px solid #eee;\n\n//     &:last-child {\n//       border-bottom: none;\n//     }\n\n//     .user-info {\n//       display: flex;\n//       align-items: center;\n//       gap: 0.6rem;\n\n//       .user-avatar {\n//         background: #1571b9;\n//         color: white;\n//         border-radius: 50%;\n//         width: 30px;\n//         height: 30px;\n//         display: flex;\n//         align-items: center;\n//         justify-content: center;\n//       }\n//     }\n\n//     .remove-btn {\n//       background: none;\n//       border: none;\n//       color: #d9534f;\n//       font-size: 1rem;\n//       cursor: pointer;\n//       transition: 0.2s;\n\n//       &:hover {\n//         color: #b52b27;\n//         transform: scale(1.1);\n//       }\n//     }\n//   }\n// }\n\n// .modal-footer {\n//   padding: 1rem 1.5rem;\n//   display: flex;\n//   justify-content: flex-end;\n//   gap: 0.8rem;\n//   border-top: 1px solid #eee;\n\n//   .btn {\n//     padding: 0.5rem 1.2rem;\n//     border-radius: 0.4rem;\n//     font-weight: 600;\n//     cursor: pointer;\n//     transition: 0.2s;\n\n//     &.cancel {\n//       background: #f0f0f0;\n//       color: #333;\n\n//       &:hover {\n//         background: #e0e0e0;\n//       }\n//     }\n\n//     &.primary {\n//       background: #1571b9;\n//       color: #fff;\n//       border: none;\n\n//       &:hover {\n//         background: #1571b9;\n//       }\n\n//       &:disabled {\n//         opacity: 0.6;\n//         cursor: not-allowed;\n//       }\n//     }\n//   }\n// }\n\n// .scrollable::-webkit-scrollbar {\n//   width: 6px;\n// }\n\n// .scrollable::-webkit-scrollbar-thumb {\n//   background: #ccc;\n//   border-radius: 3px;\n// }\n\n// @keyframes fadeIn {\n//   from {\n//     opacity: 0;\n//   }\n\n//   to {\n//     opacity: 1;\n//   }\n// }\n\n// @keyframes slideUp {\n//   from {\n//     transform: translateY(40px);\n//     opacity: 0;\n//   }\n\n//   to {\n//     transform: translateY(0);\n//     opacity: 1;\n//   }\n// }\n\n// .modal.is-active {\n//   z-index: 999999;\n// }\n\n// .more-user-modal {\n//   .modern-modal {\n//     border-radius: 16px;\n//     overflow: hidden;\n//     max-width: 420px;\n//     width: 95%;\n//     margin: auto;\n//     box-shadow: 0 8px 30px rgba(0, 0, 0, 0.15);\n//     background: #fff;\n//     animation: modalSlideUp 0.3s ease;\n//     z-index: 9999;\n\n//     .modern-modal-head {\n//       background: #f5f6fa;\n//       padding: 1rem 1.5rem;\n//       border-bottom: 1px solid #e6e6e6;\n//       display: flex;\n//       align-items: center;\n//       justify-content: space-between;\n//       order: 0;\n\n//       .modal-title {\n//         font-weight: 600;\n//         font-size: 1.1rem;\n//         color: #fff;\n//       }\n\n//       .delete {\n//         background: transparent;\n//         border: none;\n//         cursor: pointer;\n//       }\n//     }\n\n//     .modern-modal-body {\n//       padding: 1rem 1.5rem;\n//       background-color: #fff;\n\n//       .search-container {\n//         margin-bottom: 1rem;\n\n//         .search-input {\n//           border-radius: 8px;\n//           border-color: #dcdcdc;\n//           transition: all 0.2s ease;\n\n//           &:focus {\n//             border-color: #485fc7;\n//             box-shadow: 0 0 0 0.2rem rgba(72, 95, 199, 0.1);\n//           }\n//         }\n\n//         .clear-icon {\n//           color: #999;\n//           cursor: pointer;\n\n//           &:hover {\n//             color: #333;\n//           }\n//         }\n//       }\n\n//       .user-list {\n//         max-height: 340px;\n//         overflow-y: auto;\n//         padding-right: 6px;\n\n//         .user-item {\n//           display: flex;\n//           align-items: center;\n//           padding: 0.65rem 0.75rem;\n//           border-radius: 8px;\n//           margin-bottom: 0.4rem;\n//           cursor: pointer;\n//           background-color: #fafafa;\n//           transition: all 0.2s ease;\n\n//           &:hover {\n//             background-color: #f0f3ff;\n//           }\n\n//           &.active {\n//             background-color: #e0e7ff;\n//             border-left: 2px solid #485fc7;\n//           }\n\n//           .user-avatar {\n//             width: 32px;\n//             height: 32px;\n//             background-color: #eef0f5;\n//             display: flex;\n//             align-items: center;\n//             justify-content: center;\n//             border-radius: 50%;\n//             margin-right: 0.75rem;\n//             font-size: 1rem;\n//             color: #485fc7;\n//           }\n\n//           .user-name {\n//             flex: 1;\n//             font-size: 0.95rem;\n//             color: #333;\n//           }\n\n//           .check-icon {\n//             color: #485fc7;\n//           }\n//         }\n//       }\n//     }\n\n//     .modern-modal-foot {\n//       padding: 1rem 1.5rem;\n//       border-top: 1px solid #e6e6e6;\n//       display: flex;\n//       justify-content: space-between;\n//       align-items: center;\n\n//       .button {\n//         border-radius: 8px;\n//         min-width: 80px;\n//       }\n\n//       .button-group {\n//         display: flex;\n//         gap: 0.5rem;\n//       }\n//     }\n//   }\n// }\n\n// @keyframes modalSlideUp {\n//   from {\n//     transform: translateY(20px);\n//     opacity: 0;\n//   }\n\n//   to {\n//     transform: translateY(0);\n//     opacity: 1;\n//   }\n// }\n\n// /* Optional: custom scrollbar */\n// .scroll-bar::-webkit-scrollbar {\n//   width: 6px;\n// }\n\n// .scroll-bar::-webkit-scrollbar-thumb {\n//   background: #c3c7d0;\n//   border-radius: 4px;\n// }\n\n// .scroll-bar::-webkit-scrollbar-thumb:hover {\n//   background: #999;\n// }\n\n// .elibrary-header {\n//   display: flex;\n//   justify-content: space-between;\n//   align-items: center;\n//   background: #ffffff;\n//   padding: 0.75rem 1rem;\n//   border-bottom: 1px solid #e6e6e6;\n//   box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);\n//   position: relative;\n//   z-index: 10;\n\n//   .header-left {\n//     display: flex;\n//     align-items: center;\n//     gap: 0.75rem;\n\n//     .icon-btn {\n//       display: flex;\n//       align-items: center;\n//       justify-content: center;\n//       background: #f5f6fa;\n//       border-radius: 50%;\n//       width: 32px;\n//       height: 32px;\n//       color: #555;\n//       transition: all 0.2s ease;\n\n//       &:hover {\n//         background: #1571b9;\n//         color: #fff;\n//       }\n//     }\n\n//     .class-info {\n//       .class-title {\n//         font-size: 1rem;\n//         font-weight: 600;\n//         color: #333;\n//         margin: 0;\n//         max-width: 250px;\n//         overflow: hidden;\n//         text-overflow: ellipsis;\n//         white-space: nowrap;\n//       }\n\n//       .class-updated {\n//         display: block;\n//         font-size: 0.75rem;\n//         color: #888;\n//       }\n//     }\n//   }\n\n//   .header-right {\n//     display: flex;\n//     align-items: center;\n//     gap: 1rem;\n\n//     .header-search {\n//       position: relative;\n\n//       input {\n//         border: 1px solid #ddd;\n//         border-radius: 6px;\n//         padding: 0.4rem 2rem 0.4rem 1.5rem;\n//         font-size: 0.85rem;\n//         outline: none;\n//         transition: border-color 0.2s ease;\n\n//         &:focus {\n//           border-color: #1571b9;\n//         }\n//       }\n\n//       .search-icon {\n//         position: absolute;\n//         left: 8px;\n//         top: 50%;\n//         transform: translateY(-50%);\n//         color: #aaa;\n//         font-size: 0.8rem;\n//       }\n\n//       .clear-icon {\n//         position: absolute;\n//         right: 8px;\n//         top: 50%;\n//         transform: translateY(-50%);\n//         color: #999;\n//         cursor: pointer;\n\n//         &:hover {\n//           color: #333;\n//         }\n//       }\n//     }\n\n//     .view-toggle {\n//       display: flex;\n//       gap: 0.4rem;\n\n//       .toggle-btn {\n//         background: transparent;\n//         border: 1px solid #ccc;\n//         border-radius: 6px;\n//         padding: 0.3rem 0.6rem;\n//         font-size: 0.85rem;\n//         cursor: pointer;\n//         color: #555;\n//         transition: all 0.2s ease;\n\n//         &.active,\n//         &:hover {\n//           background: #1571b9;\n//           border-color: #1571b9;\n//           color: #fff;\n//         }\n//       }\n//     }\n\n//     .action-buttons {\n//       display: flex;\n//       align-items: center;\n//       gap: 0.5rem;\n\n//       .btn-upload {\n//         display: flex;\n//         align-items: center;\n//         gap: 0.3rem;\n//         background: #1571b9;\n//         color: #fff;\n//         border: none;\n//         border-radius: 6px;\n//         padding: 0.4rem 0.75rem;\n//         font-size: 0.85rem;\n//         cursor: pointer;\n//         transition: background 0.2s ease;\n\n//         &:hover {\n//           background: #0056b3;\n//         }\n\n//         .btn-text {\n//           @media (max-width: 600px) {\n//             display: none;\n//           }\n//         }\n//       }\n\n//       .btn-close {\n//         background: #f1f1f1;\n//         color: #333;\n//         border: none;\n//         border-radius: 6px;\n//         padding: 0.4rem 0.6rem;\n//         cursor: pointer;\n//         transition: background 0.2s ease;\n\n//         &:hover {\n//           background: #e0e0e0;\n//         }\n//       }\n//     }\n\n//     .btn-dashboard-close {\n//       background: transparent;\n//       border: 1px solid #1571b9;\n//       border-radius: 6px;\n//       padding: 0.4rem 0.6rem;\n//       color: #1571b9;\n//       transition: all 0.2s ease;\n\n//       &:hover {\n//         background: #1571b9;\n//         color: #fff;\n//       }\n//     }\n//   }\n\n//   @media (max-width: 768px) {\n//     flex-direction: column;\n//     align-items: flex-start;\n//     gap: 0.5rem;\n\n//     .header-right {\n//       width: 100%;\n//       justify-content: space-between;\n//       flex-wrap: wrap;\n//     }\n\n//     .header-search input {\n//       width: 100%;\n//     }\n//   }\n// }\n\n\n// .elib-header {\n//   display: flex;\n//   justify-content: space-between;\n//   align-items: center;\n//   background: #ffffff;\n//   border-radius: 10px;\n//   padding: 10px 20px;\n//   box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);\n//   flex-wrap: wrap;\n//   transition: all 0.3s ease;\n\n//   .elib-left {\n//     display: flex;\n//     align-items: center;\n//     flex-wrap: wrap;\n//     gap: 1rem;\n//   }\n\n//   .elib-info {\n//     display: flex;\n//     flex-direction: column;\n\n//     .elib-title {\n//       display: flex;\n//       align-items: center;\n//       gap: 8px;\n\n//       h3 {\n//         margin: 0;\n//         font-size: 1rem;\n//         font-weight: 600;\n//         color: #2c3e50;\n//         max-width: 200px;\n//       }\n//     }\n\n//     .elib-date {\n//       color: #888;\n//       font-size: 0.75rem;\n//     }\n//   }\n\n//   .elib-actions {\n//     display: flex;\n//     align-items: center;\n//     list-style: none;\n//     gap: 10px;\n//     margin: 0;\n//     padding: 0;\n\n//     li {\n//       cursor: pointer;\n//       color: #555;\n//       font-size: 1rem;\n//       transition: color 0.2s;\n\n//       &:hover {\n//         color: #1571b9;\n//       }\n//     }\n//   }\n\n//   .elib-right {\n//     display: flex;\n//     align-items: center;\n//     gap: 0.75rem;\n//   }\n\n//   .icon-btn {\n//     background: #f7f9fb;\n//     border: 1px solid #d9e2ec;\n//     border-radius: 8px;\n//     padding: 6px 10px;\n//     cursor: pointer;\n//     color: #444;\n//     font-size: 0.9rem;\n//     transition: all 0.2s ease;\n\n//     &:hover {\n//       background: #eaf3ff;\n//       color: #1571b9;\n//     }\n\n//     i {\n//       font-size: 1rem;\n//     }\n//   }\n\n//   .elib-search {\n//     position: relative;\n\n//     .elib-input {\n//       padding: 5px 30px;\n//       border: 1px solid #dce3eb;\n//       border-radius: 8px;\n//       font-size: 0.85rem;\n//       outline: none;\n//       transition: all 0.2s;\n\n//       &:focus {\n//         border-color: #1571b9;\n//         box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.1);\n//       }\n//     }\n\n//     .left-icon,\n//     .right-icon {\n//       position: absolute;\n//       top: 50%;\n//       transform: translateY(-50%);\n//       color: #888;\n//       font-size: 0.85rem;\n//     }\n\n//     .left-icon {\n//       left: 8px;\n//     }\n\n//     .right-icon {\n//       right: 8px;\n//       cursor: pointer;\n\n//       &:hover {\n//         color: #1571b9;\n//       }\n//     }\n//   }\n\n//   .tooltip {\n//     position: relative;\n\n//     &[data-tooltip]:hover::after {\n//       content: attr(data-tooltip);\n//       position: absolute;\n//       background: #333;\n//       color: #fff;\n//       font-size: 0.7rem;\n//       padding: 3px 6px;\n//       border-radius: 4px;\n//       top: -28px;\n//       left: 50%;\n//       transform: translateX(-50%);\n//       white-space: nowrap;\n//       opacity: 0.9;\n//     }\n//   }\n\n//   @media (max-width: 768px) {\n//     flex-direction: column;\n//     align-items: stretch;\n//     gap: 10px;\n\n//     .elib-left,\n//     .elib-right {\n//       justify-content: space-between;\n//       width: 100%;\n//     }\n\n//     .elib-search {\n//       width: 100%;\n\n//       .elib-input {\n//         width: 100%;\n//       }\n//     }\n//   }\n// }\n\n\n.elibrary-header {\n  background: #fff;\n  padding: 0.75rem 1rem;\n  border-radius: 10px;\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  flex-wrap: wrap;\n\n  .header-left {\n    display: flex;\n    align-items: center;\n    gap: 0.75rem;\n\n    .edit-btn {\n      background: #eef2ff;\n      color: #3b82f6;\n      border-radius: 50%;\n      padding: 0.4rem 0.5rem;\n      cursor: pointer;\n      transition: all 0.2s ease;\n      font-size: 0.9rem;\n\n      &:hover {\n        background: #dbeafe;\n        color: #2563eb;\n      }\n    }\n\n    .class-info {\n      display: flex;\n      flex-direction: column;\n\n      .class-title {\n        font-size: 1rem;\n        font-weight: 600;\n        color: #111827;\n        margin: 0;\n        max-width: 220px;\n        white-space: nowrap;\n        overflow: hidden;\n        text-overflow: ellipsis;\n      }\n\n      .class-updated {\n        font-size: 0.75rem;\n        color: #6b7280;\n      }\n    }\n  }\n\n  .header-right {\n    display: flex;\n    align-items: center;\n    gap: 1rem;\n    flex-wrap: wrap;\n\n    .search-box {\n      position: relative;\n\n      .input-search {\n        padding: 0.4rem 1.8rem 0.4rem 2rem;\n        border-radius: 8px;\n        border: 1px solid #d1d5db;\n        font-size: 0.9rem;\n        transition: all 0.2s;\n\n        &:focus {\n          outline: none;\n          border-color: #3b82f6;\n          box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.2);\n        }\n      }\n\n      .search-icon {\n        position: absolute;\n        left: 8px;\n        top: 8px;\n        color: #9ca3af;\n        font-size: 0.9rem;\n      }\n\n      .clear-icon {\n        position: absolute;\n        right: 8px;\n        top: 8px;\n        color: #6b7280;\n        cursor: pointer;\n        font-size: 0.9rem;\n\n        &:hover {\n          color: #ef4444;\n        }\n      }\n    }\n\n    .view-toggle {\n      display: flex;\n      gap: 0.4rem;\n\n      .toggle-btn {\n        border: 1px solid #d1d5db;\n        background: #f9fafb;\n        border-radius: 6px;\n        padding: 0.3rem 0.6rem;\n        cursor: pointer;\n        transition: all 0.2s ease;\n\n        &:hover {\n          background: #f3f4f6;\n        }\n\n        &.active {\n          background: #3b82f6;\n          color: #fff;\n          border-color: #3b82f6;\n        }\n\n        i {\n          font-size: 0.9rem;\n        }\n      }\n    }\n\n    .action-buttons {\n      display: flex;\n      gap: 0.6rem;\n\n\n\n      .btn {\n        border: none;\n        border-radius: 6px;\n        font-size: 0.85rem;\n        display: flex;\n        align-items: center;\n        gap: 0.3rem;\n        padding: 0.35rem 0.75rem;\n        cursor: pointer;\n        transition: all 0.2s ease;\n\n        i {\n          font-size: 0.85rem;\n        }\n\n        &.upload-btn {\n          background: #10b981;\n          color: #fff;\n\n          &:hover {\n            background: #059669;\n          }\n\n          .text {\n            @media (max-width: 768px) {\n              display: none;\n            }\n          }\n        }\n\n        &.close-btn {\n          background: #f87171;\n          color: #fff;\n\n          &:hover {\n            background: #dc2626;\n          }\n        }\n      }\n    }\n  }\n}\n\n.elib-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  background: #ffffff;\n  border-bottom: 1px solid #e0e0e0;\n  padding: 0.75rem 1rem;\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);\n  position: sticky;\n  top: 0;\n  z-index: 20;\n\n  .elib-header-left {\n    display: flex;\n    align-items: center;\n    gap: 0.75rem;\n\n    .toggle-btn {\n      background: #f5f6fa;\n      border: none;\n      border-radius: 8px;\n      padding: 0.4rem 0.6rem;\n      cursor: pointer;\n      transition: all 0.3s ease;\n\n      &:hover {\n        background: #e3e6f0;\n      }\n\n      i {\n        font-size: 1.2rem;\n        color: #555;\n      }\n    }\n\n    .class-info {\n      display: flex;\n      flex-direction: column;\n      justify-content: center;\n\n      .class-name {\n        font-size: 1rem;\n        font-weight: 600;\n        color: #2c3e50;\n        margin: 0;\n      }\n\n      .updated-time {\n        font-size: 0.8rem;\n        color: #888;\n      }\n    }\n\n    .action-icons {\n      display: flex;\n      align-items: center;\n      list-style: none;\n      gap: 0.75rem;\n      margin: 0;\n      padding: 0;\n\n      .ai-button {\n        border: 1px solid #dcdcdc;\n        border-radius: 8px;\n        padding: 0.4rem 0.6rem;\n        cursor: pointer;\n        transition: all 0.3s ease;\n        background: #e7eaf0;\n      }\n\n      li {\n        cursor: pointer;\n        padding: 0.5rem;\n        border-radius: 6px;\n        transition: background 0.3s;\n\n        &:hover {\n          background: #f1f3f7;\n        }\n\n        &:has(.btn-icon) {\n          padding: 0;\n          background: transparent;\n\n          &:hover {\n            background: transparent;\n          }\n        }\n\n        i {\n          font-size: 1.1rem;\n          color: #555;\n        }\n\n        img {\n          width: 30px;\n        }\n\n        .btn-icon {\n          background: #f8f9fb;\n          border: 1px solid #dcdcdc;\n          border-radius: 8px;\n          padding:4px 6px;\n          cursor: pointer;\n          transition: all 0.3s ease;\n          display: flex;\n          align-items: center;\n          justify-content: center;\n\n          &:hover {\n            background: #e7eaf0;\n            border-color: #b8bcc4;\n          }\n\n          img {\n            width: 30px;\n            height: auto;\n            display: block;\n          }\n        }\n      }\n    }\n  }\n\n  .elib-header-right {\n    display: flex;\n    align-items: center;\n    gap: 1rem;\n\n\n\n    .elib-actions {\n      display: flex;\n      align-items: center;\n      gap: 0.75rem;\n\n      .btn-icon {\n        background: #f8f9fb;\n        border: 1px solid #dcdcdc;\n        border-radius: 8px;\n        padding: 0.4rem 0.6rem;\n        cursor: pointer;\n        transition: all 0.3s ease;\n\n        &:hover {\n          background: #e7eaf0;\n        }\n\n        i {\n          color: #007ad9;\n          font-size: 1rem;\n        }\n      }\n\n      .search-box {\n        position: relative;\n        display: flex;\n        align-items: center;\n        background: #f8f9fb;\n        border: 1px solid #dcdcdc;\n        border-radius: 20px;\n        padding: 0.3rem 0.8rem;\n        // width: 200px;\n        // transition: width 0.3s ease;\n\n        &:focus-within {\n          // width: 250px;\n          border-color: #007ad9;\n        }\n\n        .search-input {\n          border: none;\n          background: transparent;\n          outline: none;\n          flex: 1;\n          font-size: 0.9rem;\n          color: #333;\n        }\n\n        .left-icon,\n        .right-icon {\n          color: #999;\n          font-size: 0.85rem;\n        }\n\n        .left-icon {\n          margin-right: 0.4rem;\n        }\n\n        .right-icon {\n          cursor: pointer;\n          margin-left: 0;\n\n          &:hover {\n            color: #555;\n          }\n        }\n      }\n    }\n  }\n\n  /* Responsive */\n  @media (max-width: 766px) {\n    flex-wrap: wrap;\n    gap: 0.75rem;\n    padding: 0.5rem 0.75rem;\n\n    .elib-header-left {\n      width: 100%;\n      justify-content: space-between;\n      flex-wrap: wrap;\n      gap: 0.5rem;\n\n      .class-info {\n        flex: 1;\n        min-width: 0;\n\n        .class-name {\n          font-size: 0.9rem;\n          max-width: 100%;\n          overflow: hidden;\n          text-overflow: ellipsis;\n          white-space: nowrap;\n        }\n\n        .updated-time {\n          font-size: 0.7rem;\n        }\n      }\n\n      .action-icons {\n        gap: 0.5rem;\n\n\n\n        li {\n          padding: 0.4rem;\n          min-width: 40px;\n          min-height: 40px;\n          display: flex;\n          align-items: center;\n          justify-content: center;\n\n          &:has(.btn-icon) {\n            padding: 0;\n            min-width: auto;\n            min-height: auto;\n          }\n\n          img {\n            width: 24px;\n          }\n\n          .btn-icon {\n            min-width: 44px;\n            min-height: 44px;\n            padding: 0.5rem;\n\n            img {\n              width: 24px;\n            }\n          }\n        }\n      }\n    }\n\n    .elib-header-right {\n      width: 100%;\n      justify-content: space-between;\n      flex-wrap: wrap;\n      gap: 0.5rem;\n\n      .elib-actions {\n        width: 100%;\n        flex-wrap: wrap;\n        gap: 0.5rem;\n\n        .btn-icon {\n          min-width: 44px;\n          min-height: 44px;\n          padding: 0.5rem;\n          font-size: 0.85rem;\n\n          i {\n            font-size: 0.9rem;\n          }\n        }\n\n        .search-box {\n          width: 100%;\n          max-width: 100%;\n          flex: 1;\n          min-width: 0;\n\n          &:focus-within {\n            width: 100%;\n          }\n        }\n      }\n    }\n  }\n\n  @media (max-width: 480px) {\n    padding: 0.5rem;\n\n    .elib-header-left {\n      .toggle-btn {\n        min-width: 44px;\n        min-height: 44px;\n        padding: 0.5rem;\n      }\n\n      .class-info {\n        .class-name {\n          font-size: 0.85rem;\n        }\n\n        .updated-time {\n          font-size: 0.65rem;\n        }\n      }\n\n      .action-icons {\n        gap: 0.4rem;\n\n        li {\n          padding: 0.35rem;\n          min-width: 36px;\n          min-height: 36px;\n\n          &:has(.btn-icon) {\n            padding: 0;\n            min-width: auto;\n            min-height: auto;\n          }\n\n          img {\n            width: 20px;\n          }\n\n          .btn-icon {\n            min-width: 40px;\n            min-height: 40px;\n            padding: 0.4rem;\n\n            img {\n              width: 20px;\n            }\n          }\n        }\n      }\n    }\n\n    .elib-header-right {\n      .elib-actions {\n        .btn-icon {\n          font-size: 0.8rem;\n          padding: 0.4rem 0.5rem;\n\n          i {\n            font-size: 0.85rem;\n          }\n        }\n      }\n    }\n  }\n}\n\n.elib-container {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  height: 100%;\n  // background: var(--surface-section, #f9fafb);\n  // border-radius: 1rem;\n  overflow: hidden;\n  // box-shadow: 0 0 10px rgba(0, 0, 0, 0.08);\n\n  .elib-content {\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n    padding: 1rem;\n\n    .elib-scroll-area {\n      height: 100%;\n      /* or fixed height like 80vh or 500px */\n      max-height: calc(100vh - 114px);\n      /* adjust if inside a modal or layout */\n      overflow-y: auto;\n      overflow-x: hidden;\n      scroll-behavior: smooth;\n\n      &::-webkit-scrollbar {\n        width: 6px;\n      }\n\n      &::-webkit-scrollbar-thumb {\n        background: #bdbdbd;\n        border-radius: 4px;\n      }\n\n      &::-webkit-scrollbar-thumb:hover {\n        background: #9e9e9e;\n      }\n    }\n\n    .elib-tile-view,\n    .elib-dashboard {\n      // display: flex;\n      flex-wrap: wrap;\n      gap: 1rem;\n      transition: all 0.3s ease-in-out;\n\n      app-e-library-tile,\n      app-e-library-dashboard {\n        width: 100%;\n        background: #fff;\n        border-radius: 0.75rem;\n        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);\n        transition: transform 0.2s ease, box-shadow 0.2s ease;\n\n        &:hover {\n          transform: translateY(-3px);\n          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n        }\n      }\n    }\n  }\n}\n\n/* Optional responsive adjustments */\n@media (max-width: 992px) {\n  .elib-content {\n    padding: 0.5rem;\n\n    .elib-tile-view,\n    .elib-dashboard {\n      gap: 0.75rem;\n    }\n  }\n}\n\n/* Tablet range: 767px - 940px - Specific fix for mobile responsive */\n@media (min-width: 767px) and (max-width: 940px) {\n  .elib-header {\n    padding: 0.65rem 0.9rem !important;\n    flex-wrap: nowrap !important;\n    display: flex !important;\n    align-items: center !important;\n\n    .elib-header-left {\n      flex: 1 1 auto !important;\n      min-width: 0 !important;\n      width: auto !important;\n      gap: 0.85rem !important;\n      justify-content: flex-start !important;\n      flex-wrap: nowrap !important;\n      display: flex !important;\n      align-items: center !important;\n\n      .toggle-btn {\n        flex-shrink: 0 !important;\n        min-width: 40px !important;\n        min-height: 40px !important;\n      }\n\n      .class-info {\n        flex: 1 1 auto !important;\n        min-width: 0 !important;\n        overflow: hidden !important;\n\n        .class-name {\n          font-size: 0.95rem !important;\n          max-width: 160px !important;\n          overflow: hidden !important;\n          text-overflow: ellipsis !important;\n          white-space: nowrap !important;\n        }\n\n        .updated-time {\n          font-size: 0.75rem !important;\n        }\n      }\n\n      .action-icons {\n        gap: 0.5rem !important;\n        flex-shrink: 0 !important;\n        display: flex !important;\n        align-items: center !important;\n\n        li {\n          padding: 0.4rem !important;\n          min-width: 36px !important;\n          min-height: 36px !important;\n          display: flex !important;\n          align-items: center !important;\n          justify-content: center !important;\n\n          img {\n            width: 24px !important;\n            height: auto !important;\n          }\n        }\n      }\n    }\n\n    .elib-header-right {\n      flex: 0 0 auto !important;\n      width: auto !important;\n      gap: 0.75rem !important;\n      justify-content: flex-end !important;\n      flex-wrap: nowrap !important;\n      display: flex !important;\n      align-items: center !important;\n\n      .elib-actions {\n        width: auto !important;\n        gap: 0.6rem !important;\n        flex-wrap: nowrap !important;\n        display: flex !important;\n        align-items: center !important;\n\n        .btn-icon {\n          padding: 0.4rem 0.5rem !important;\n          font-size: 0.85rem !important;\n          min-width: 40px !important;\n          min-height: 40px !important;\n          white-space: nowrap !important;\n\n          i {\n            font-size: 0.9rem !important;\n          }\n        }\n\n        .search-box {\n          width: 160px !important;\n          max-width: 160px !important;\n          flex: 0 0 auto !important;\n          min-width: 160px !important;\n\n          &:focus-within {\n            width: 200px !important;\n            max-width: 200px !important;\n          }\n\n          .search-input {\n            font-size: 0.85rem !important;\n          }\n        }\n      }\n    }\n  }\n\n  .elib-content {\n    padding: 0.75rem !important;\n\n    .elib-scroll-area {\n      max-height: calc(100vh - 170px) !important;\n    }\n\n    .elib-tile-view,\n    .elib-dashboard {\n      gap: 0.65rem !important;\n    }\n  }\n\n  .modal-container {\n    width: 90% !important;\n    max-width: 600px !important;\n  }\n\n  .upload-modal {\n    width: 90% !important;\n    max-width: 700px !important;\n  }\n\n  .more-user-modal {\n    .modern-modal {\n      max-width: 500px !important;\n      width: 90% !important;\n    }\n  }\n\n  .modal-body {\n    padding: 1.25rem !important;\n  }\n\n  .modal-footer {\n    padding: 0.9rem 1.25rem !important;\n  }\n}\n\n/* Tablet range: 767px - 956px */\n@media (min-width: 767px) and (max-width: 956px) {\n  .elib-header {\n    padding: 0.65rem 0.9rem !important;\n    flex-wrap: nowrap !important;\n\n    .elib-header-left {\n      flex: 1 !important;\n      min-width: 0 !important;\n      width: auto !important;\n      gap: 0.85rem !important;\n      justify-content: flex-start !important;\n      flex-wrap: nowrap !important;\n\n      .class-info {\n        flex: 1 !important;\n        min-width: 0 !important;\n\n        .class-name {\n          font-size: 0.95rem !important;\n          max-width: 180px !important;\n        }\n\n        .updated-time {\n          font-size: 0.75rem !important;\n        }\n      }\n\n      .action-icons {\n        gap: 0.6rem !important;\n\n        li {\n          padding: 0.45rem !important;\n          min-width: 38px !important;\n          min-height: 38px !important;\n\n          img {\n            width: 26px !important;\n          }\n        }\n      }\n    }\n\n    .elib-header-right {\n      flex: 0 0 auto !important;\n      width: auto !important;\n      gap: 0.85rem !important;\n      justify-content: flex-end !important;\n      flex-wrap: nowrap !important;\n\n      .elib-actions {\n        width: auto !important;\n        gap: 0.65rem !important;\n        flex-wrap: nowrap !important;\n\n        .btn-icon {\n          padding: 0.45rem 0.55rem !important;\n          font-size: 0.88rem !important;\n          min-width: 42px !important;\n          min-height: 42px !important;\n\n          i {\n            font-size: 0.95rem !important;\n          }\n        }\n\n        .search-box {\n          width: 180px !important;\n          max-width: 180px !important;\n          flex: 0 0 auto !important;\n\n          &:focus-within {\n            width: 220px !important;\n            max-width: 220px !important;\n          }\n        }\n      }\n    }\n  }\n\n  .elib-content {\n    padding: 0.75rem;\n\n    .elib-scroll-area {\n      max-height: calc(100vh - 170px);\n    }\n\n    .elib-tile-view,\n    .elib-dashboard {\n      gap: 0.65rem;\n    }\n  }\n\n  .modal-container {\n    width: 85%;\n    max-width: 600px;\n  }\n\n  .upload-modal {\n    width: 85%;\n    max-width: 700px;\n  }\n\n  .more-user-modal {\n    .modern-modal {\n      max-width: 500px;\n      width: 90%;\n    }\n  }\n\n  .modal-body {\n    padding: 1.25rem;\n  }\n\n  .modal-footer {\n    padding: 0.9rem 1.25rem;\n  }\n}\n\n@media (max-width: 766px) {\n  .elib-content {\n    padding: 0.5rem;\n\n    .elib-scroll-area {\n      max-height: calc(100vh - 200px);\n    }\n\n    .elib-tile-view,\n    .elib-dashboard {\n      gap: 0.5rem;\n    }\n  }\n}\n\n@media (max-width: 576px) {\n  .elib-container {\n    border-radius: 0;\n    box-shadow: none;\n  }\n\n  .elib-content {\n    padding: 0.25rem;\n\n    .elib-scroll-area {\n      max-height: calc(100vh - 180px);\n    }\n  }\n}\n\n/* Overlay and container */\n.modal-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(17, 24, 39, 0.6);\n  backdrop-filter: blur(4px);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1050;\n}\n\n.modal-container {\n  background: #ffffff;\n  border-radius: 16px;\n  width: 550px;\n  max-height: 90vh;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  box-shadow: 0 12px 30px rgba(0, 0, 0, 0.15);\n  animation: slideIn 0.3s ease-out;\n\n  @media (min-width: 767px) and (max-width: 956px) {\n    width: 85% !important;\n    max-width: 600px !important;\n    max-height: 92vh !important;\n    border-radius: 14px !important;\n  }\n\n  @media (max-width: 766px) {\n    width: 95%;\n    max-width: 95%;\n    max-height: 95vh;\n    border-radius: 12px;\n  }\n\n  @media (max-width: 480px) {\n    width: 100%;\n    max-width: 100%;\n    max-height: 100vh;\n    border-radius: 0;\n    margin: 0;\n  }\n}\n\n@keyframes slideIn {\n  from {\n    opacity: 0;\n    transform: translateY(-20px);\n  }\n\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n/* Header */\n.modal-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  background: linear-gradient(135deg, #1571b9, #4c8dff);\n  border-bottom: 1px solid #e5e7eb;\n  padding: 1rem 1.5rem;\n\n  h3 {\n    margin: 0;\n    font-weight: 600;\n    color: #fff;\n    font-size: 1.1rem;\n  }\n\n  .close-btn {\n    background: transparent;\n    border: none;\n    font-size: 1.2rem;\n    color: #fff;\n    cursor: pointer;\n    transition: color 0.2s;\n    min-width: 44px;\n    min-height: 44px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border-radius: 4px;\n\n    &:hover {\n      background: rgba(255, 255, 255, 0.1);\n      color: #fff;\n    }\n  }\n\n  @media (max-width: 480px) {\n    padding: 0.75rem 1rem;\n\n    h3 {\n      font-size: 1rem;\n    }\n\n    .close-btn {\n      min-width: 40px;\n      min-height: 40px;\n      font-size: 1.1rem;\n    }\n  }\n}\n\n/* Body */\n.modal-body {\n  padding: 1.5rem;\n  overflow-y: auto;\n  flex: 1;\n\n  @media (min-width: 767px) and (max-width: 956px) {\n    padding: 1.25rem !important;\n  }\n\n  @media (max-width: 766px) {\n    padding: 1rem;\n  }\n\n  @media (max-width: 480px) {\n    padding: 0.75rem;\n  }\n}\n\n.form-group {\n  margin-bottom: 1.25rem;\n\n  label {\n    font-weight: 500;\n    display: block;\n    margin-bottom: 0.5rem;\n    color: #374151;\n    font-size: 0.95rem;\n  }\n\n  .required {\n    color: #ef4444;\n  }\n\n  .input-control,\n  .textarea-control,\n  .select-control {\n    width: 100%;\n    padding: 0.65rem 0.8rem;\n    border: 1px solid #d1d5db;\n    border-radius: 8px;\n    font-size: 0.95rem;\n    transition: border-color 0.2s, box-shadow 0.2s;\n    min-height: 44px;\n\n    &:focus {\n      outline: none;\n      border-color: #3b82f6;\n      box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.15);\n    }\n  }\n\n  .textarea-control {\n    min-height: 80px;\n    resize: vertical;\n  }\n\n  @media (min-width: 767px) and (max-width: 956px) {\n    margin-bottom: 1.15rem !important;\n\n    label {\n      font-size: 0.93rem !important;\n    }\n\n    .input-control,\n    .textarea-control,\n    .select-control {\n      font-size: 0.93rem !important;\n      padding: 0.63rem 0.78rem !important;\n    }\n  }\n\n  @media (max-width: 480px) {\n    margin-bottom: 1rem;\n\n    label {\n      font-size: 0.9rem;\n    }\n\n    .input-control,\n    .textarea-control,\n    .select-control {\n      font-size: 0.9rem;\n      padding: 0.6rem 0.75rem;\n    }\n  }\n}\n\n.label-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 0.5rem;\n\n  @media (min-width: 767px) and (max-width: 956px) {\n    gap: 0.6rem !important;\n\n    .add-user-btn {\n      padding: 0.45rem 0.85rem !important;\n      font-size: 0.88rem !important;\n    }\n  }\n\n  @media (max-width: 480px) {\n    flex-direction: column;\n    align-items: flex-start;\n\n    label {\n      width: 100%;\n    }\n\n    .add-user-btn {\n      width: 100%;\n      justify-content: center;\n    }\n  }\n}\n\n/* Buttons */\n.btn {\n  padding: 0.6rem 1.2rem;\n  border-radius: 8px;\n  font-weight: 500;\n  cursor: pointer;\n  border: none;\n  transition: background 0.2s, color 0.2s, transform 0.1s;\n\n  &.primary {\n    background: #3b82f6;\n    color: white;\n\n    &:disabled {\n      background: #93c5fd;\n      cursor: not-allowed;\n    }\n\n    &:hover:not(:disabled) {\n      background: #2563eb;\n    }\n  }\n\n  &.outline {\n    background: transparent;\n    border: 1px solid #d1d5db;\n    color: #374151;\n\n    &:hover {\n      background: #f3f4f6;\n    }\n  }\n\n  &.small {\n    padding: 0.4rem 0.8rem;\n    font-size: 0.85rem;\n  }\n}\n\n.icon-btn {\n  border: none;\n  background: none;\n  cursor: pointer;\n  color: #6b7280;\n  transition: color 0.2s;\n\n  &:hover {\n    color: #111827;\n  }\n\n  &.danger:hover {\n    color: #dc2626;\n  }\n}\n\n/* User List */\n.user-list {\n  background: #f9fafb;\n  border-radius: 8px;\n  padding: 0.5rem;\n  max-height: 220px;\n  overflow-y: auto;\n  border: 1px solid #e5e7eb;\n\n  .user-item {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 0.6rem 0.75rem;\n    border-bottom: 1px solid #e5e7eb;\n    min-height: 44px;\n\n    &:last-child {\n      border-bottom: none;\n    }\n\n    .user-info {\n      display: flex;\n      align-items: center;\n      gap: 0.6rem;\n      flex: 1;\n      min-width: 0;\n\n      .avatar {\n        width: 30px;\n        height: 30px;\n        background: #e0e7ff;\n        color: #3b82f6;\n        border-radius: 50%;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        flex-shrink: 0;\n      }\n\n      .user-name {\n        font-size: 0.95rem;\n        color: #374151;\n        overflow: hidden;\n        text-overflow: ellipsis;\n        white-space: nowrap;\n      }\n    }\n\n    .icon-btn {\n      min-width: 44px;\n      min-height: 44px;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n    }\n\n    @media (max-width: 480px) {\n      padding: 0.5rem;\n      min-height: 40px;\n\n      .user-info {\n        .avatar {\n          width: 28px;\n          height: 28px;\n          font-size: 0.9rem;\n        }\n\n        .user-name {\n          font-size: 0.9rem;\n        }\n      }\n\n      .icon-btn {\n        min-width: 40px;\n        min-height: 40px;\n      }\n    }\n  }\n\n  @media (max-width: 480px) {\n    max-height: 200px;\n    padding: 0.4rem;\n  }\n}\n\n/* Footer */\n.modal-footer {\n  padding: 1rem 1.5rem;\n  border-top: 1px solid #e5e7eb;\n  display: flex;\n  justify-content: flex-end;\n  gap: 0.8rem;\n  background: #f9fafb;\n  flex-wrap: wrap;\n\n  @media (min-width: 767px) and (max-width: 956px) {\n    padding: 0.9rem 1.25rem !important;\n    gap: 0.65rem !important;\n  }\n\n  @media (max-width: 766px) {\n    padding: 0.75rem 1rem;\n    gap: 0.5rem;\n  }\n\n  @media (max-width: 480px) {\n    padding: 0.75rem;\n    flex-direction: column-reverse;\n    gap: 0.5rem;\n\n    .btn {\n      width: 100%;\n      min-height: 44px;\n    }\n  }\n}\n\n.upload-modal-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(20, 20, 20, 0.55);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1050;\n  backdrop-filter: blur(4px);\n}\n\n.upload-modal {\n  background: #fff;\n  width: 80%;\n  max-width: 100%;\n  border-radius: 6px;\n  box-shadow: 0 12px 30px rgba(0, 0, 0, 0.15);\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  animation: fadeInUp 0.25s ease-out;\n  max-height: 90vh;\n\n  @media (min-width: 767px) and (max-width: 956px) {\n    width: 85% !important;\n    max-width: 700px !important;\n    max-height: 92vh !important;\n  }\n\n  @media (max-width: 766px) {\n    width: 95%;\n    max-height: 95vh;\n  }\n\n  @media (max-width: 480px) {\n    width: 100%;\n    max-width: 100%;\n    max-height: 100vh;\n    border-radius: 0;\n    margin: 0;\n  }\n}\n\n.upload-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  background: linear-gradient(135deg, #1571b9, #5b9dff);\n  color: #fff;\n  padding: 1rem 1.5rem;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.1);\n  order: 0;\n\n  .fa-solid,\n  .fa {\n    color: #fff !important;\n  }\n\n  .upload-header-left {\n    display: flex;\n    align-items: center;\n    gap: 0.75rem;\n\n    .upload-icon {\n      background: rgba(255, 255, 255, 0.15);\n      width: 44px;\n      height: 44px;\n      border-radius: 50%;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n\n      i {\n        font-size: 1.4rem;\n      }\n    }\n\n    .upload-group-info {\n      .upload-title {\n        font-size: 1.2rem;\n        font-weight: 600;\n        margin: 0;\n      }\n\n      .upload-subtitle {\n        font-size: 0.9rem;\n        opacity: 0.85;\n        margin-top: 2px;\n      }\n    }\n  }\n\n  .upload-close-btn {\n    background: transparent;\n    border: none;\n    color: #fff;\n    font-size: 1.3rem;\n    cursor: pointer;\n    transition: transform 0.2s ease;\n    min-width: 44px;\n    min-height: 44px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border-radius: 4px;\n\n    &:hover {\n      background: rgba(255, 255, 255, 0.1);\n      transform: scale(1.1);\n    }\n  }\n\n  @media (min-width: 767px) and (max-width: 956px) {\n    padding: 0.9rem 1.2rem !important;\n\n    .upload-header-left {\n      gap: 0.65rem !important;\n\n      .upload-icon {\n        width: 40px !important;\n        height: 40px !important;\n\n        i {\n          font-size: 1.3rem !important;\n        }\n      }\n\n      .upload-group-info {\n        .upload-title {\n          font-size: 1.1rem !important;\n        }\n\n        .upload-subtitle {\n          font-size: 0.85rem !important;\n        }\n      }\n    }\n\n    .upload-close-btn {\n      min-width: 42px !important;\n      min-height: 42px !important;\n      font-size: 1.2rem !important;\n    }\n  }\n\n  @media (max-width: 480px) {\n    padding: 0.75rem 1rem;\n\n    .upload-header-left {\n      gap: 0.5rem;\n\n      .upload-icon {\n        width: 36px;\n        height: 36px;\n\n        i {\n          font-size: 1.2rem;\n        }\n      }\n\n      .upload-group-info {\n        .upload-title {\n          font-size: 1rem;\n        }\n\n        .upload-subtitle {\n          font-size: 0.8rem;\n        }\n      }\n    }\n\n    .upload-close-btn {\n      min-width: 40px;\n      min-height: 40px;\n      font-size: 1.1rem;\n    }\n  }\n}\n\n.upload-body {\n  // padding: 1.5rem;\n  background: #f9fafb;\n  flex: 1;\n  overflow-y: auto;\n\n  .upload-shell {\n    border: 2px dashed #cfd8dc;\n    border-radius: 12px;\n    background: #fff;\n    padding: 1.25rem;\n    text-align: center;\n    transition: border-color 0.3s;\n\n    &:hover {\n      border-color: #1571b9;\n    }\n  }\n}\n\n.upload-footer {\n  display: flex;\n  justify-content: flex-end;\n  padding: 1rem 1.5rem;\n  background: #fff;\n  border-top: 1px solid #eee;\n  gap: 0.5rem;\n\n  .btn-cancel {\n    background: #f3f4f6;\n    border: none;\n    color: #333;\n    padding: 0.6rem 1.2rem;\n    border-radius: 8px;\n    cursor: pointer;\n    font-weight: 500;\n    transition: background 0.2s;\n\n    &:hover {\n      background: #e0e0e0;\n    }\n  }\n}\n\n@keyframes fadeInUp {\n  from {\n    transform: translateY(25px);\n    opacity: 0;\n  }\n\n  to {\n    transform: translateY(0);\n    opacity: 1;\n  }\n}\n\n.modal {\n  z-index: 99999;\n}\n\n.more-user-modal {\n  .modern-modal {\n    border-radius: 12px;\n    overflow: hidden;\n    background: #fff;\n    box-shadow: 0 10px 25px rgba(0, 0, 0, 0.15);\n    max-width: 420px;\n    width: 95%;\n    margin: auto;\n    transition: all 0.3s ease;\n    z-index: 9999;\n    max-height: 90vh;\n    display: flex;\n    flex-direction: column;\n\n    @media (min-width: 767px) and (max-width: 956px) {\n      max-width: 500px !important;\n      width: 90% !important;\n      max-height: 92vh !important;\n    }\n\n    @media (max-width: 766px) {\n      max-width: 95%;\n      width: 95%;\n      max-height: 95vh;\n    }\n\n    @media (max-width: 480px) {\n      width: 100%;\n      max-width: 100%;\n      margin: 0;\n      border-radius: 0;\n      max-height: 100vh;\n    }\n  }\n\n  .modern-modal-head {\n    background: linear-gradient(135deg, #1571b9, #4c8dff);\n    color: #fff;\n    padding: 1rem 1.2rem;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    order: 0;\n\n    .modal-title {\n      font-weight: 600;\n      font-size: 1.1rem;\n      display: flex;\n      align-items: center;\n      gap: 8px;\n    }\n\n    .delete {\n      background: transparent;\n      color: #fff;\n      opacity: 0.8;\n      transition: 0.2s;\n\n      &:hover {\n        opacity: 1;\n      }\n    }\n  }\n\n  .modern-modal-body {\n    padding: 1rem 1.2rem;\n    background: #f9fafc;\n    max-height: 60vh;\n    overflow-y: auto;\n    flex: 1;\n\n    @media (min-width: 767px) and (max-width: 956px) {\n      padding: 0.9rem 1.1rem !important;\n      max-height: 62vh !important;\n    }\n\n    @media (max-width: 766px) {\n      padding: 0.75rem 1rem;\n      max-height: 65vh;\n    }\n\n    @media (max-width: 480px) {\n      padding: 0.75rem;\n      max-height: calc(100vh - 200px);\n    }\n\n    .search-container {\n      margin-bottom: 1rem;\n\n      .search-input {\n        border-radius: 8px;\n        border: 1px solid #dcdcdc;\n        transition: 0.2s;\n\n        &:focus {\n          border-color: #1571b9;\n          box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.15);\n        }\n      }\n\n      .clear-icon {\n        cursor: pointer;\n        color: #999;\n\n        &:hover {\n          color: #333;\n        }\n      }\n    }\n\n    .select-all-container {\n      margin-bottom: 0.75rem;\n      padding-bottom: 0.75rem;\n      border-bottom: 1px solid #e0e0e0;\n\n      .select-all-item {\n        display: flex;\n        align-items: center;\n        gap: 12px;\n        border-radius: 8px;\n        padding: 0.75rem;\n        cursor: pointer;\n        transition: all 0.25s ease;\n        min-height: 44px;\n        background: #f5f7fa;\n\n        &:hover {\n          background: #eef5ff;\n        }\n\n        &.active {\n          background: #dceeff;\n          border-left: 3px solid #1571b9;\n        }\n\n        .user-avatar {\n          background: #e8f0fe;\n          border-radius: 50%;\n          width: 38px;\n          height: 38px;\n          display: flex;\n          align-items: center;\n          justify-content: center;\n          color: #1571b9;\n          font-size: 1.2rem;\n          flex-shrink: 0;\n        }\n\n        .user-name {\n          flex: 1;\n          font-weight: 600;\n          color: #333;\n          overflow: hidden;\n          text-overflow: ellipsis;\n          white-space: nowrap;\n        }\n\n        .check-icon {\n          color: #1571b9;\n          font-size: 1.2rem;\n          flex-shrink: 0;\n        }\n      }\n    }\n\n    .user-list {\n      .user-item {\n        display: flex;\n        align-items: center;\n        gap: 12px;\n        // background: #fff;\n        border-radius: 8px;\n        padding: 0.75rem;\n        margin-bottom: 0.5rem;\n        cursor: pointer;\n        transition: all 0.25s ease;\n        min-height: 44px;\n        // box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);\n\n        &:hover {\n          background: #eef5ff;\n        }\n\n        &.active {\n          background: #dceeff;\n          border-left: 3px solid #1571b9;\n        }\n\n        .user-avatar {\n          background: #e8f0fe;\n          border-radius: 50%;\n          width: 38px;\n          height: 38px;\n          display: flex;\n          align-items: center;\n          justify-content: center;\n          color: #1571b9;\n          font-size: 1.2rem;\n          flex-shrink: 0;\n        }\n\n        .user-name {\n          flex: 1;\n          font-weight: 500;\n          color: #333;\n          overflow: hidden;\n          text-overflow: ellipsis;\n          white-space: nowrap;\n        }\n\n        .check-icon {\n          color: #1571b9;\n          font-size: 1.2rem;\n          flex-shrink: 0;\n        }\n\n        @media (min-width: 767px) and (max-width: 956px) {\n          padding: 0.7rem !important;\n          gap: 11px !important;\n          min-height: 42px !important;\n\n          .user-avatar {\n            width: 36px !important;\n            height: 36px !important;\n            font-size: 1.1rem !important;\n          }\n\n          .user-name {\n            font-size: 0.93rem !important;\n          }\n\n          .check-icon {\n            font-size: 1.1rem !important;\n          }\n        }\n\n        @media (max-width: 480px) {\n          padding: 0.6rem;\n          gap: 10px;\n          min-height: 40px;\n\n          .user-avatar {\n            width: 32px;\n            height: 32px;\n            font-size: 1rem;\n          }\n\n          .user-name {\n            font-size: 0.9rem;\n          }\n\n          .check-icon {\n            font-size: 1rem;\n          }\n        }\n      }\n    }\n  }\n\n  .modern-modal-foot {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    background: #fff;\n    padding: 0.75rem 1.2rem;\n    border-top: 1px solid #eee;\n    flex-wrap: wrap;\n    gap: 0.5rem;\n\n    .button {\n      border-radius: 8px;\n      font-weight: 500;\n      transition: 0.2s ease-in-out;\n      min-height: 44px;\n    }\n\n    .clear-btn {\n      color: #6c757d;\n\n      &:hover {\n        background: #f3f3f3;\n      }\n    }\n\n    .cancel-btn {\n      background: #f3f3f3;\n      color: #333;\n\n      &:hover {\n        background: #e9e9e9;\n      }\n    }\n\n    .add-btn {\n      background: #1571b9;\n      color: #fff;\n\n      &:hover {\n        background: #1571b9;\n      }\n    }\n\n    @media (min-width: 767px) and (max-width: 956px) {\n      padding: 0.85rem 1.1rem !important;\n      gap: 0.6rem !important;\n\n      .button {\n        min-height: 42px !important;\n        padding: 0.5rem 1rem !important;\n      }\n    }\n\n    @media (max-width: 480px) {\n      padding: 0.75rem;\n      flex-direction: column-reverse;\n\n      .button {\n        width: 100%;\n      }\n\n      .button-group {\n        width: 100%;\n        display: flex;\n        gap: 0.5rem;\n\n        .button {\n          flex: 1;\n        }\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
